import { useParams } from "react-router-dom";
import { Formik } from "formik";
import {
  generateDynamicComponent,
  getSectionForm,
  postProcessData,
  preProcessData,
  useEncounter,
  useComment,
  useMedicationRequest,
  useUtil,
} from "../hooks";
import { useFormikContext } from "formik";
import "../style.css";
import {
  Alert,
  Button,
  Divider,
  Grid,
  Stack,
  Paper,
  LinearProgress,
} from "@mui/material";
import {
  AlertDialog,
  MgpButton,
  MgpModal,
  MgpText,
  Padding,
} from "../components/global";

import { useEffect, useState, useRef } from "react";
import MgpProgressBar from "../components/global/MgpProgressBar";
import { Box } from "@mui/system";
import * as React from "react";
import * as yup from "yup";
import { colors } from "../theme/colors";
import MedicationRequest from "./MedicationRequest";
import { useNavigate } from "react-router-dom";
import MgpComment from "../components/global/MgpComment";
import { useRbac, usePatient } from "../hooks";
import { PatientReject } from "./PatientApproval/PatientReject";
import Loader from "./Loader/Loader";
import MgpAlertBar from "../components/global/MgpAlertBar";
import LivingStatus from "./LivingStatus";
import { ENV, StorageHelper, readMutationErrorMessage } from "../helpers";
import {
  isNonCitizenNationality,
  withPatientIsCitizen,
} from "../helpers/gccNationalId";
import {
  clearPendingComments,
  readPendingComments,
} from "../helpers/pendingEncounterComments";
import { NoteAlertDialog } from "../components/global/NoteAlertDialog";
import { useIdleTimer } from "react-idle-timer";

const PATIENT_CONTEXT_STORAGE_KEY = "patientRegistrationContext";

const readPatientRegistrationContext = (params = {}) => {
  try {
    const context = JSON.parse(
      window.sessionStorage.getItem(PATIENT_CONTEXT_STORAGE_KEY) || "{}"
    );
    if (
      params.nationalId &&
      context.nationalId &&
      String(context.nationalId) !== String(params.nationalId)
    ) {
      return {};
    }
    if (
      params.patientId &&
      context.patientId &&
      String(context.patientId) !== String(params.patientId)
    ) {
      return {};
    }
    return context;
  } catch (err) {
    return {};
  }
};

export const Patient = ({
  viewMode,
  newVisit,
  reopen = false,
  editable = true,
}) => {
  const formikRef = React.useRef(null);
  const { RbacWrapper, getActionRbac } = useRbac();
  const [approve, setApprove] = useState(false);
  const [serotype, setserotype] = useState(false);
  const [savedraft, setSaveDraft] = useState(0);
  const [livingStatusOpen, setlivingStatusOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitFeedback, setSubmitFeedback] = useState(false);
  const [submitReopen, setSubmitReopen] = useState(false);
  const [reject, setOpenReject] = useState(false);
  const params = useParams();
  const patientRegistrationContext = React.useMemo(
    () => readPatientRegistrationContext(params),
    [params.nationalId, params.patientId]
  );
  const verifyRegisterNationality = patientRegistrationContext.nationality;
  const isCitizenUrlParam =
    typeof patientRegistrationContext.isCitizen === "boolean"
      ? patientRegistrationContext.isCitizen
        ? "true"
        : "false"
      : null;
  const verifyCountryOfResidenceParam =
    patientRegistrationContext.countryOfResidence;
  const registrationIdIssuingCountry =
    params.nationalId && patientRegistrationContext.nationalId
      ? patientRegistrationContext.idIssuingCountry || undefined
      : undefined;

  const {
    useAddPatientWithEncounter,
    useUpdatePatient,
    useUpdatePatientWithEncounter,
    useUpdatePatientAndAddEncounter,
    useUpdatePatientLivingStatus,
  } = usePatient();
  const [AddPatientWithEncounter] = useAddPatientWithEncounter;
  const [UpdatePatient] = useUpdatePatient;
  const [UpdatePatientWithEncounter] = useUpdatePatientWithEncounter;
  const [UpdatePatientAndAddEncounter] = useUpdatePatientAndAddEncounter;
  const [reload, setReload] = useState({});
  const [alertOption, setAlertOption] = useState(false);
  const {
    useAddEncounter,
    useGetEncounter,
    useUpdateEncounter,
    useUpdatePatientFollowUpsDetails,
  } = useEncounter({
    patientId: 1,
  });
  const { useSubmitComment, useAddComment } = useComment({
    encounterId: 1,
    attributeId: "",
  });
  const { useAddMedicationRequests } = useMedicationRequest();
  const [AddMedicationRequests] = useAddMedicationRequests;

  const [AddEncounter] = useAddEncounter;
  const [GetEncounter] = useGetEncounter;
  const [SubmitComment, { data, loading, error }] = useSubmitComment;
  const [AddCommentForEncounter] = useAddComment;

  const [Update_Encounter] = useUpdateEncounter;
  const [UpdatePatientFollowUpsDetails] = useUpdatePatientFollowUpsDetails;
  const [UpdatePatientLivingStatus] = useUpdatePatientLivingStatus;
  const navigate = useNavigate();

  const flushPendingEncounterComments = (patientId, encounterIdNum) => {
    if (patientId == null || patientId === "" || !encounterIdNum) {
      return Promise.resolve();
    }
    const pending = readPendingComments(patientId);
    if (!pending.length) {
      clearPendingComments(patientId);
      return Promise.resolve();
    }
    return pending.reduce(
      (seq, row) =>
        seq.then(
          () =>
            new Promise((resolve, reject) => {
              AddCommentForEncounter({
                variables: {
                  comment: row.comment,
                  encounterId: encounterIdNum,
                  attributeId: row.attributeId,
                  label: row.label,
                  section: row.section,
                },
                onCompleted: resolve,
                onError: reject,
              });
            })
        ),
      Promise.resolve()
    ).then(() => clearPendingComments(patientId));
  };


  const [forms, setForms] = useState([]);
  const [message, setMessage] = useState("");
  const [submitErrors, setSubmitErrors] = useState({});
  const [submitTouched, setSubmitTouched] = useState({});

  const {
    patient_form,
    getValidationSchema,
    setSelectedSection,
    patient_selected_section,
    getInitialValue,
    encountedData,
    encountedDataLatestStatus,
    setEncountedDataLatestStatus,
    commentData,
    setCommentData,
    encounterData,
    pageLoad,
    encountedDatamain,
    patientActive,
    patientData,
    setCrfError,
    crfErrors,
    setCrfTouch,
    crfTouch,
  } = useUtil();

  let user = JSON.parse(StorageHelper.get("user"));
  const isPiiLessPatient = patientData?.ViewPatient
    ? patientData.ViewPatient.pii_collected === false
    : user?.collect_pii === false;

  const wrapDemographic = React.useCallback(
    (demographic) => {
      // PII-less patients skip VerifyPatient, so the nationality dropdown is the only citizen/resident choice.
      if (isPiiLessPatient && demographic?.nationality) {
        return {
          ...demographic,
          is_citizen: !isNonCitizenNationality(demographic.nationality),
        };
      }
      return withPatientIsCitizen(demographic, {
        urlParam: isCitizenUrlParam,
        stored: encountedDatamain?.is_citizen,
      });
    },
    [isPiiLessPatient, isCitizenUrlParam, encountedDatamain?.is_citizen]
  );

  const getCountryOfResidence = React.useCallback((demography = {}) => {
    return (
      demography?.country_of_residence ||
      demography?.countryofresidence ||
      verifyCountryOfResidenceParam ||
      demography?.countrylist ||
      ""
    );
  }, [verifyCountryOfResidenceParam]);

  const getFlatCountryOfResidence = React.useCallback((data = {}) => {
    return (
      data?.demography_country_of_residence ||
      data?.demography_countryofresidence ||
      verifyCountryOfResidenceParam ||
      data?.demography_countrylist ||
      ""
    );
  }, [verifyCountryOfResidenceParam]);

  useEffect(() => {
    setForms(getSectionForm(patient_selected_section, patient_form?.attribute));
  }, [patient_selected_section]);
  const [activeStep, setActiveStep] = useState(newVisit ? 0 : 0);
  const [errorOpen, setErrorOpen] = useState(false);
  const [autoSaveAlert, setAutoSaveAlert] = useState(false);
  // Refs so the 10s interval sees the latest in-flight / manual-save state
  const autoSaveInFlightRef = useRef(false);
  const mainPageloadingRef = useRef(false);

  const [completed, setCompleted] = useState({});

  const [mainPageloading, setMainPageloading] = useState(false);
  // Lock Submit/Next/etc while a manual save OR autosave is in flight
  const buttonsLocked = mainPageloading || pageLoad || autoSaveAlert;
  const acceptedPathsList = ["Edit", "newVisit", "newPatient"];
  const [Allerrors, setAllerrors] = useState([]);

  useEffect(() => {
    mainPageloadingRef.current = mainPageloading;
  }, [mainPageloading]);

  const ppciDemographic = (getPpciFields) =>
    isPiiLessPatient ? {} : getPpciFields();

  const urlWindow = window.location;

  // Auto Save to Database <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<----------------------------------------------------------------------------------
  const handleOnIdleSave = () => {
    console.log("User is idle", encountedDatamain?.status);
    // Do not overlap with another autosave or a user-driven Submit/Next save
    if (autoSaveInFlightRef.current || mainPageloadingRef.current) {
      return;
    }
    if (formikRef?.current?.values !== undefined) {
      if (
        window.location.href.includes("visitHistory") &&
        (parseInt(user?.role_id) === parseInt(ENV.doctor_role_id) ||
          (parseInt(user?.role_id) === parseInt(ENV.medical_lead_role_id) &&
            encounterData?.GetEncountersByPatientId?.[0]?.["self"])) &&
        (parseInt(encountedDatamain?.status) === 0 || // Draft
          parseInt(encountedDatamain?.status) === 4 || // Returned to Doctor
          parseInt(encountedDatamain?.status) === 5) // Re-Opened
      ) {
        const encounterId = parseInt(params.encounterId);
        const data = formikRef.current.values;
        const originalFormat = convertToOriginalFormat(data);
        const values = postProcessData(originalFormat);
        if (values) {
          const encounterDetails = { ...values };
          delete encounterDetails.demography;
          delete encounterDetails.PPCI;
          const patientIdForSave =
            encountedDatamain?.["patient_id"] ??
            parseInt(params?.patientId, 10);
          if (!patientIdForSave || !encounterId) {
            setAutoSaveAlert(false);
            return;
          }
          autoSaveInFlightRef.current = true;
          setAutoSaveAlert(true);
          UpdatePatientWithEncounter({
            variables: {
              patientId: patientIdForSave,
              input: {
                Demographic: wrapDemographic({
                  dob:
                    data?.demography_dateofbirth === ""
                      ? null
                      : data?.demography_dateofbirth,
                  age:
                    data?.demography_age === ""
                      ? null
                      : data?.demography_age,
                  education: data?.demography_educationallevel,
                  employment: data?.demography_employment,
                  gender: data?.demography_gender,
                  city: data?.demography_city,
                  region: data?.demography_region,
                  country: data?.demography_countrylist,
                  country_of_residence: getFlatCountryOfResidence(data),
                  marital: data?.demography_maritalstatus,
                  nationality: data?.demography_nationality,
                  smoking_status: data?.demography_smokerstatus,
                  consentform: data?.PPCI_consentform,
                  ...ppciDemographic(() => ({
                    email: data?.PPCI_email,
                    first_name: data?.PPCI_firstname,
                    last_name: data?.PPCI_lastname,
                    mobile: data?.PPCI_phonenumber,
                    mrn_no: data?.PPCI_mrnno,
                    national_id: data?.PPCI_nationalid?.toString(),
                  })),
                }),
              },
              encounterId: parseInt(encounterId, 10),
              encounterDetails,
              encounterIsAutoSave: true,
            },
            onCompleted: (res) => {
              console.log("The auto save is completed", res);
              autoSaveInFlightRef.current = false;
              setAutoSaveAlert(false);
            },
            onError: () => {
              autoSaveInFlightRef.current = false;
              setAutoSaveAlert(false);
            },
          });
        }
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleOnIdleSave();
    }, 10000); // 10 seconds
    return () => clearInterval(interval);
  }, [handleOnIdleSave]);

  // ---------------------------------------------------------------------------------------------->>>>>>>>>>>>>>
  let newData = {};
  if (acceptedPathsList?.includes(urlWindow.pathname.split("/")[3])) {
    newData = {
      ...patient_form,
      sections: patient_form?.sections?.filter((_, index) => index === 0),
    };
  }
  const [notemessage, setnotemessage] = useState("");
  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;

    setCompleted(newCompleted);
    handleNext();
  };

  const handleLivingClose = () => {
    setlivingStatusOpen(false);
  };
  const totalSteps = () => {
    return acceptedPathsList?.includes(urlWindow.pathname.split("/")[3])
      ? newData?.sections.length
      : patient_form?.sections.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  const [medicationArray, setMedicationArray] = useState([]);

  useEffect(() => {
    if (medicationArray.length > 0) {
      submitPatient(finalvalues);
    }
  }, [medicationArray]);

  const handleBack = () => {
    var element = document.getElementById("scroller");

    if (acceptedPathsList?.includes(urlWindow.pathname.split("/")[3])) {
      setSelectedSection(newData?.sections[activeStep - 1].key);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      element.scrollIntoView();
    } else {
      setSelectedSection(patient_form?.sections[activeStep - 1].key);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      element.scrollIntoView();
    }
  };

  const handleNext = (values) => {
    if (acceptedPathsList?.includes(urlWindow.pathname.split("/")[3])) {
      const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? // It's the last step, but not all steps have been completed,
            // find the first step that has been completed
            newData?.sections.findIndex((step, i) => !(i in completed))
          : activeStep + 1;
      setSelectedSection(newData?.sections[newActiveStep].key);
      setActiveStep(newActiveStep);
    } else {
      const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? // It's the last step, but not all steps have been completed,
            // find the first step that has been completed
            patient_form?.sections.findIndex((step, i) => !(i in completed))
          : activeStep + 1;
      setSelectedSection(patient_form?.sections[newActiveStep].key);

      setActiveStep(newActiveStep);
    }
  };

  useEffect(() => {
    // if (formikRef?.current !== null) {
    //   formikRef?.current?.validateForm().then((resp) => {
    //     let processeddata = postProcessData(resp);
    //     let err = preProcessData(processeddata);
    //     setAllerrors(err);
    //   });
    // }
  }, [activeStep]);

  const [registry_no, setregistry_no] = useState({});
  const [encounterdata, setencounterdata] = useState({});

  const showMutationError = (error) => {
    setErrorMessage(readMutationErrorMessage(error));
    setErrorOpen(true);
    setMainPageloading(false);
  };

  /** Persist newly created patient/encounter IDs so later saves update the same record. */
  const rememberCreatedRecord = (payload, formValues) => {
    const patient = payload?.patient;
    const enc = payload?.encounter ?? payload;
    if (patient) {
      setregistry_no({ AddPatient: patient });
    }
    if (enc?.encounter_id) {
      StorageHelper.set(enc.encounter_id, JSON.stringify(formValues));
      setencounterdata({ AddEncounter: enc });
      navigate(`/app/patients/visitHistory/${enc.encounter_id}`);
    }
  };

  const getVisitTypeLabelFromFollowUp = (encounter, fallbackType = "") => {
    const followUp = encounter?.follow_up;

    if (followUp !== undefined && followUp !== null && followUp !== "") {
      return parseInt(followUp, 10) === 0
        ? "Baseline Visit"
        : `Follow Up Visit (${followUp})`;
    }

    return fallbackType || "Baseline Visit";
  };

  const convertToNestedObject = (input) => {
    const output = { ...input };
    const nestedFields = [
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale",
    ];

    nestedFields.forEach((field) => {
      const fieldValue = output[field];
      if (fieldValue && typeof fieldValue === "object") {
        Object.entries(fieldValue).forEach(([key, value]) => {
          const nestedFieldKey = `${field}_${key}`;
          output[nestedFieldKey] = value;
        });
        delete output[field];
      }
    });

    return output;
  };

  const convertToOriginalFormat = (data) => {
    const output = { ...data };
    const nestedFields = [
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale",
    ];

    nestedFields.forEach((field) => {
      const nestedObject = {};
      Object.keys(output).forEach((key) => {
        if (key.startsWith(`${field}_`)) {
          const nestedKey = key.replace(`${field}_`, "");
          nestedObject[nestedKey] = output[key];
          delete output[key];
        }
      });
      output[field] = nestedObject;
    });

    return output;
  };

  const CreateRegistraionNumber = (value) => {
    setMainPageloading(true);
    if (value) {
      value["basicVisit_typeofvisit"] = "Baseline Visit";
    }
    const originalFormat = convertToOriginalFormat(value);
    const values = postProcessData(originalFormat);
    const encounterDetailsForCreate = { ...values };
    delete encounterDetailsForCreate.demography;
    delete encounterDetailsForCreate.PPCI;
    AddPatientWithEncounter({
      variables: {
        input: {
          Demographic: wrapDemographic({
            nationality:
              values?.demography?.nationality || verifyRegisterNationality,
            country_of_residence: getCountryOfResidence(values?.demography),
            id_issuing_country: registrationIdIssuingCountry,
            is_draft: true,
            consentform: values?.PPCI?.consentform,
            ...ppciDemographic(() => ({
              email: values?.PPCI?.email,
              first_name: values?.PPCI?.firstname,
              last_name: values?.PPCI?.lastname,
              mobile: values?.PPCI?.phonenumber,
              mrn_no: values?.PPCI?.mrnno,
              national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
            })),
          }),
        },
        encounterDetails: encounterDetailsForCreate,
        encounterStatus: 0,
      },
      onCompleted: (res) => {
        const payload = res?.AddPatientWithEncounter;
        const patient = payload?.patient;
        setMessage(
          patient?.pii_collected === false
            ? `A new patient has been registered successfully ${patient?.registry_no}`
            : `A new patient has been registered successfully ${patient?.first_name} ${patient?.last_name}`
        );
        if (payload?.encounter) {
          StorageHelper.set("LivingStatus", JSON.stringify("basicVisit"));
        }
        rememberCreatedRecord(payload, value);
        setMainPageloading(false);
        setEncountedDataLatestStatus(0);
        setAlertOption(true);
        handleNext(value);
        setSaveDraft(2);
      },
      onError: (error) => {
        if (readMutationErrorMessage(error) === "Mrn no. Exists")
          setErrorMessage("MRN number already exists");
        else setErrorMessage(readMutationErrorMessage(error));
        setErrorOpen(true);
        setMainPageloading(false);
      },
    });
  };
  const submitPatient = (data, submit, savedraft) => {
    // setencounterdata({});
    setMainPageloading(true);
    console.log("savedDraft", savedraft);

    const originalFormat = convertToOriginalFormat(data);
    const values = postProcessData(originalFormat);
    const encounterDetails = values ? { ...values } : values;
    if (encounterDetails) {
      delete encounterDetails.demography;
      delete encounterDetails.PPCI;
    }
    if (
      urlWindow.pathname.split("/")[3] === "Edit" &&
      patient_selected_section === "PPCI"
    ) {
      UpdatePatient({
        variables: {
          input: {
            Demographic: wrapDemographic({
              dob:
                values?.demography?.dateofbirth === ""
                  ? null
                  : values?.demography?.dateofbirth,
              age:
                values?.demography?.year === ""
                  ? null
                  : `${values?.demography?.year}/${values?.demography?.month}`,
              education: values?.demography?.educationallevel,
              employment: values?.demography?.employment,
              gender: values?.demography?.gender,
              city: values?.demography?.city,
              region: values?.demography?.region,
              country: values?.demography?.countrylist,
              country_of_residence: getCountryOfResidence(values?.demography),
              marital: values?.demography?.maritalstatus,
              nationality: values?.demography?.nationality,
              smoking_status: values?.demography?.smokerstatus,
              consentform: values?.PPCI?.consentform,
              ...ppciDemographic(() => ({
                email: values?.PPCI?.email,
                first_name: values?.PPCI?.firstname,
                last_name: values?.PPCI?.lastname,
                mobile: values?.PPCI?.phonenumber,
                mrn_no: values?.PPCI?.mrnno,
                national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
              })),
            }),
          },
          patientId: params?.nationalId
            ? parseInt(registry_no?.AddPatient?.patient_id)
            : encountedDatamain?.["patient_id"],
        },
        onCompleted: (data) => {
          setMessage("Profile has been updated");
          setMainPageloading(false);
          setAlertOption(true);
          setEncountedDataLatestStatus(1);
        },
        onError: (error) => {
          showMutationError(error);
        },
      });
    } else {
      if ((savedraft === 1 || savedraft === 2) && !submit) {
        if (!params?.patientId) {
          if (
            !encountedDatamain?.["status"] &&
            encountedDatamain?.["status"] !== 0 &&
            !params?.nationalId
          ) {
            AddPatientWithEncounter({
              variables: {
                input: {
                  Demographic: wrapDemographic({
                    id_issuing_country: registrationIdIssuingCountry,
                    dob:
                      values?.demography?.dateofbirth === ""
                        ? null
                        : values?.demography?.dateofbirth,
                    age:
                      values?.demography?.year === ""
                        ? null
                        : `${values?.demography?.year}/${values?.demography?.month}`,
                    education: values?.demography?.educationallevel,
                    employment: values?.demography?.employment,
                    gender: values?.demography?.gender,
                    city: values?.demography?.city,
                    region: values?.demography?.region,
                    country: values?.demography?.countrylist,
                    country_of_residence: getCountryOfResidence(
                      values?.demography
                    ),
                    marital: values?.demography?.maritalstatus,
                    nationality: values?.demography?.nationality,
                    smoking_status: values?.demography?.smokerstatus,
                    is_draft: true,
                    consentform: values?.PPCI?.consentform,
                    ...ppciDemographic(() => ({
                      email: values?.PPCI?.email,
                      first_name: values?.PPCI?.firstname,
                      last_name: values?.PPCI?.lastname,
                      mobile: values?.PPCI?.phonenumber,
                      mrn_no: values?.PPCI?.mrnno,
                      national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
                    })),
                  }),
                },
                encounterDetails,
                encounterStatus: 0,
              },
              onCompleted: (res) => {
                rememberCreatedRecord(res?.AddPatientWithEncounter, data);
                setMessage(
                  isPiiLessPatient
                    ? "A new patient has been registered successfully"
                    : `A new patient has been registered successfully ${values?.PPCI?.firstname} ${values?.PPCI?.lastname}`
                );
                setAlertOption(true);
                setMainPageloading(false);
                setEncountedDataLatestStatus(0);
              },
              onError: (error) => {
                showMutationError(error);
              },
            });
          } else {
            if (encountedDatamain?.["status"] === 0 || params?.nationalId) {
              UpdatePatientWithEncounter({
                variables: {
                  patientId: params?.nationalId
                    ? parseInt(registry_no?.AddPatient?.patient_id)
                    : encountedDatamain?.["patient_id"],
                  input: {
                    Demographic: wrapDemographic({
                      dob:
                        values?.demography?.dateofbirth === ""
                          ? null
                          : values?.demography?.dateofbirth,
                      age:
                        values?.demography?.year === ""
                          ? null
                          : `${values?.demography?.year}/${values?.demography?.month}`,
                      education: values?.demography?.educationallevel,
                      employment: values?.demography?.employment,
                      gender: values?.demography?.gender,
                      city: values?.demography?.city,
                      region: values?.demography?.region,
                      country: values?.demography?.countrylist,
                      country_of_residence: getCountryOfResidence(
                        values?.demography
                      ),
                      marital: values?.demography?.maritalstatus,
                      nationality: values?.demography?.nationality,
                      smoking_status: values?.demography?.smokerstatus,
                      is_draft: true,
                      consentform: values?.PPCI?.consentform,
                      ...ppciDemographic(() => ({
                        email: values?.PPCI?.email,
                        first_name: values?.PPCI?.firstname,
                        last_name: values?.PPCI?.lastname,
                        mobile: values?.PPCI?.phonenumber,
                        mrn_no: values?.PPCI?.mrnno,
                        national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
                      })),
                    }),
                  },
                  encounterId: params?.nationalId
                    ? parseInt(encounterdata?.AddEncounter?.encounter_id)
                    : parseInt(params?.encounterId),
                  encounterDetails,
                  encounterStatus: 0,
                },
                onCompleted: (res) => {
                  const encId =
                    res?.UpdatePatientWithEncounter?.encounter?.encounter_id;
                  if (medicationArray.length > 0) {
                    const updatedData = medicationArray.map((item) => ({
                      ...item,
                      encounter_id: encId,
                    }));
                    AddMedicationRequests({
                      variables: {
                        encounterId: encId,
                        requests: updatedData,
                      },
                      onCompleted: async (res) => {
                        if (savedraft === 2) {
                          // setMessage(
                          //   "Patient Record Draft Updated Successfully"
                          // );
                          // setAlertOption(true);
                        }
                        setMainPageloading(false);
                        setEncountedDataLatestStatus(0);
                      },
                      onError: (error) => {
                        showMutationError(error);
                      },
                    });
                  } else {
                    if (savedraft === 2) {
                      // setMessage(
                      //   "Patient Record Draft Updated Successfully"
                      // );
                      // setAlertOption(true);
                    }
                    setMainPageloading(false);
                    setEncountedDataLatestStatus(0);
                  }
                },
                onError: (error) => {
                  showMutationError(error);
                },
              });
            }
          }
        } else {
          UpdatePatientAndAddEncounter({
            variables: {
              patientId: params?.nationalId
                ? parseInt(registry_no?.AddPatient?.patient_id)
                : params?.patientId,
              input: {
                Demographic: wrapDemographic({
                  dob:
                    values?.demography?.dateofbirth === ""
                      ? null
                      : values?.demography?.dateofbirth,
                  age:
                    values?.demography?.year === ""
                      ? null
                      : `${values?.demography?.year}/${values?.demography?.month}`,
                  education: values?.demography?.educationallevel,
                  employment: values?.demography?.employment,
                  gender: values?.demography?.gender,
                  city: values?.demography?.city,
                  region: values?.demography?.region,
                  country: values?.demography?.countrylist,
                  country_of_residence: getCountryOfResidence(
                    values?.demography
                  ),
                  marital: values?.demography?.maritalstatus,
                  nationality: values?.demography?.nationality,
                  smoking_status: values?.demography?.smokerstatus,
                  is_draft: true,
                  consentform: values?.PPCI?.consentform,
                  ...ppciDemographic(() => ({
                    email: values?.PPCI?.email,
                    first_name: values?.PPCI?.firstname,
                    last_name: values?.PPCI?.lastname,
                    mobile: values?.PPCI?.phonenumber,
                    mrn_no: values?.PPCI?.mrnno,
                    national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
                  })),
                }),
              },
              encounterDetails,
              encounterStatus: 0,
            },
            onCompleted: async (res) => {
              const enc = res?.UpdatePatientAndAddEncounter?.encounter;
              const encId = parseInt(enc?.encounter_id, 10);
              if (params?.patientId) {
                try {
                  await flushPendingEncounterComments(
                    params.patientId,
                    encId
                  );
                } catch (e) {
                  console.error(e);
                  setErrorMessage(
                    e?.message ||
                      "Some comments could not be saved to the server"
                  );
                  setErrorOpen(true);
                }
              }
              if (savedraft === 2) {
                if (values.basicVisit.typeofvisit === "Baseline Visit")
                  setMessage("Patient CRF saved and locked successfully");
                else
                  setMessage(
                    "Follow up visit saved and locked successfully"
                  );
              }

              StorageHelper.set(
                "LivingStatus",
                JSON.stringify("LivingStatus")
              );
              rememberCreatedRecord({ encounter: enc }, data);
              setAlertOption(true);
              setMainPageloading(false);
              setEncountedDataLatestStatus(0);
            },
            onError: (error) => {
              showMutationError(error);
            },
          });
        }
      } else {
        if (!params?.patientId) {
          if (
            encountedDatamain?.["status"] === 0 ||
            encounterdata?.AddEncounter?.status === 0
          ) {
            UpdatePatientWithEncounter({
              variables: {
                patientId: encountedDatamain?.["patient_id"]
                  ? encountedDatamain?.["patient_id"]
                  : encounterdata?.AddEncounter?.patient_id,
                input: {
                  Demographic: wrapDemographic({
                    dob:
                      values?.demography?.dateofbirth === ""
                        ? null
                        : values?.demography?.dateofbirth,
                    age:
                      values?.demography?.year === ""
                        ? null
                        : `${values?.demography?.year}/${values?.demography?.month}`,
                    education: values?.demography?.educationallevel,
                    employment: values?.demography?.employment,
                    gender: values?.demography?.gender,
                    city: values?.demography?.city,
                    region: values?.demography?.region,
                    country: values?.demography?.countrylist,
                    country_of_residence: getCountryOfResidence(
                      values?.demography
                    ),
                    marital: values?.demography?.maritalstatus,
                    nationality: values?.demography?.nationality,
                    smoking_status: values?.demography?.smokerstatus,
                    is_draft: false,
                    consentform: values?.PPCI?.consentform,
                    ...ppciDemographic(() => ({
                      email: values?.PPCI?.email,
                      first_name: values?.PPCI?.firstname,
                      last_name: values?.PPCI?.lastname,
                      mobile: values?.PPCI?.phonenumber,
                      mrn_no: values?.PPCI?.mrnno,
                      national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
                    })),
                  }),
                },
                encounterId: params?.encounterId
                  ? parseInt(params?.encounterId)
                  : parseInt(encounterdata?.AddEncounter?.encounter_id),
                encounterDetails,
                encounterStatus: 1,
              },
              onCompleted: (res) => {
                const encId =
                  res?.UpdatePatientWithEncounter?.encounter?.encounter_id;
                if (medicationArray.length > 0) {
                  const updatedData = medicationArray.map((item) => ({
                    ...item,
                    encounter_id: encId,
                  }));
                  AddMedicationRequests({
                    variables: {
                      encounterId: encId,
                      requests: updatedData,
                    },
                    onCompleted: async (res) => {
                      if (
                        values.basicVisit.typeofvisit === "Baseline Visit"
                      )
                        setMessage(
                          "Patient CRF saved and locked successfully"
                        );
                      else
                        setMessage(
                          "Follow up visit saved and locked successfully"
                        );
                      setAlertOption(true);
                      setMainPageloading(false);
                      setEncountedDataLatestStatus(0);
                    },
                    onError: (error) => {
                      showMutationError(error);
                    },
                  });
                } else {
                  if (values.basicVisit.typeofvisit === "Baseline Visit")
                    setMessage("Patient CRF saved and locked successfully");
                  else
                    setMessage(
                      "Follow up visit saved and locked successfully"
                    );

                  setMainPageloading(false);
                  setEncountedDataLatestStatus(0);
                  setAlertOption(true);
                }
              },
              onError: (error) => {
                showMutationError(error);
              },
            });
          } else {
            AddPatientWithEncounter({
              variables: {
                input: {
                  Demographic: wrapDemographic({
                    id_issuing_country: registrationIdIssuingCountry,
                    dob:
                      values?.demography?.dateofbirth === ""
                        ? null
                        : values?.demography?.dateofbirth,
                    age:
                      values?.demography?.year === ""
                        ? null
                        : `${values?.demography?.year}/${values?.demography?.month}`,
                    education: values?.demography?.educationallevel,
                    employment: values?.demography?.employment,
                    gender: values?.demography?.gender,
                    city: values?.demography?.city,
                    region: values?.demography?.region,
                    country: values?.demography?.countrylist,
                    country_of_residence: getCountryOfResidence(
                      values?.demography
                    ),
                    marital: values?.demography?.maritalstatus,
                    nationality: values?.demography?.nationality,
                    smoking_status: values?.demography?.smokerstatus,
                    is_draft: false,
                    consentform: values?.PPCI?.consentform,
                    ...ppciDemographic(() => ({
                      email: values?.PPCI?.email,
                      first_name: values?.PPCI?.firstname,
                      last_name: values?.PPCI?.lastname,
                      mobile: values?.PPCI?.phonenumber,
                      mrn_no: values?.PPCI?.mrnno,
                      national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
                    })),
                  }),
                },
                encounterDetails,
                encounterStatus: 1,
              },
              onCompleted: (res) => {
                const payload = res?.AddPatientWithEncounter;
                rememberCreatedRecord(payload, data);
                const encId = payload?.encounter?.encounter_id;
                if (medicationArray.length > 0) {
                  const updatedData = medicationArray.map((item) => ({
                    ...item,
                    encounter_id: encId,
                  }));
                  AddMedicationRequests({
                    variables: {
                      encounterId: encId,
                      requests: updatedData,
                    },
                    onCompleted: async (res) => {
                      if (savedraft === 2) {
                        if (
                          values.basicVisit.typeofvisit === "Baseline Visit"
                        )
                          setMessage(
                            "Patient CRF saved and locked successfully"
                          );
                        else
                          setMessage(
                            "Follow up visit saved and locked successfully"
                          );
                      }
                      setAlertOption(true);
                      setMainPageloading(false);
                      setEncountedDataLatestStatus(0);
                    },
                    onError: (error) => {
                      showMutationError(error);
                    },
                  });
                } else {
                  if (savedraft === 2) {
                    if (values.basicVisit.typeofvisit === "Baseline Visit")
                      setMessage("Patient CRF saved and locked successfully");
                    else
                      setMessage(
                        "Follow up visit saved and locked successfully"
                      );
                  }
                  setMainPageloading(false);
                  setEncountedDataLatestStatus(0);
                  setAlertOption(true);
                }
              },
              onError: (error) => {
                showMutationError(error);
              },
            });
          }
        } else {
          AddEncounter({
            variables: {
              patientId: parseInt(params?.patientId),
              encounterStartdate: new Date().toLocaleDateString("en-GB"),
              encounterEnddate: new Date().toLocaleDateString("en-GB"),
              details: encounterDetails,
              status: 1,
            },
            onCompleted: async (res) => {
              const enc = res?.AddEncounter;
              rememberCreatedRecord({ encounter: enc }, data);
              const encId = parseInt(enc?.encounter_id, 10);
              if (params?.patientId) {
                try {
                  await flushPendingEncounterComments(
                    params.patientId,
                    encId
                  );
                } catch (e) {
                  console.error(e);
                  setErrorMessage(
                    e?.message ||
                      "Some comments could not be saved to the server"
                  );
                  setErrorOpen(true);
                }
              }
              if (values.basicVisit.typeofvisit === "Baseline Visit")
                setMessage("Patient CRF saved and locked successfully");
              else setMessage("Follow up visit saved and locked successfully");
              setAlertOption(true);
              setMainPageloading(false);
              setEncountedDataLatestStatus(1);
            },
            onError: (error) => {
              showMutationError(error);
            },
          });
        }
      }
    }
  };
  const handleSubmitClose = () => {
    setAlertOption(false);
    setSubmitOpen(false);
    console.log("savedraft", savedraft, encounterdata);
    if (savedraft === 1 || savedraft === 0) {
      setTimeout(() => {
        setSubmitOpen(false);
        // if (!Object.keys(encounterdata).length > 0) {
        if (encounterId) {
          StorageHelper.remove(encounterId);
        }
        updateFollowUpsFromBaseline(() => {
          navigate("/app/patients/patientlist");
        }, encountedDataLatestStatus);
        // }
      }, 1000);
    }
  };
  const handleErrorClose = () => {
    setErrorOpen(false);
    handleNext(formikRef?.current?.values);
    var element = document.getElementById("scroller");
    element?.scrollIntoView();
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  useEffect(() => {}, [reload]);
  const [open, setOpen] = React.useState(false);
  const [submitOpen, setSubmitOpen] = React.useState(false);
  const [formikValues, setFormikValues] = useState({});
  const handleClose = () => {
    // setSelectedSection(patient_form?.sections[7].key);
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const [finalvalues, setfinalvalues] = React.useState({});
  useEffect(() => {
    if (Object.keys(finalvalues).length > 0) {
      setOpen(true);
    }
  }, [finalvalues]);

  const [numberofCount, setNumberOfCount] = useState(false);
  const commentCount = (attributName, count) => {
    setNumberOfCount(
      !getActionRbac("patients", "edit_patient_form") && count > 0
        ? false
        : true
    );
  };

  const crfValidationAttributes = isPiiLessPatient
    ? patient_form?.attribute?.filter((attr) => attr.section !== "PPCI")
    : patient_form?.attribute;

  const validationSchema = getValidationSchema(
    crfValidationAttributes,
    false,
    formikRef?.current?.values
  );

  /**
   * Rebuild Yup rules from the current form values (dependent / visit-type rules),
   * then return a Formik-shaped errors object. Used on Submit so validation is
   * not stuck on a schema built from stale values.
   */
  const validateCrfForm = (values) => {
    const schema = getValidationSchema(
      crfValidationAttributes,
      false,
      values
    );
    return schema
      .validate(values, { abortEarly: false })
      .then(() => ({}))
      .catch((err) => {
        const errors = {};
        if (err?.inner?.length) {
          err.inner.forEach((e) => {
            if (e.path && errors[e.path] === undefined) {
              errors[e.path] = e.message;
            }
          });
        } else if (err?.path) {
          errors[err.path] = err.message;
        }
        return errors;
      });
  };
  const previousValuesRef = useRef(null);
  const previousValuesErrorRef = useRef(null);

  const handleFormikChange = async (e, attr, updatedValues) => {
    delete submitErrors?.[e];
    delete submitTouched?.[e];
    delete submitErrors?.[e];
    delete submitTouched?.[e];
    if (attr?.removeerrorkeys) {
      if (Array.isArray(attr?.removeerrorkeys)) {
        attr?.removeerrorkeys.forEach((key) => {
          delete submitErrors?.[key];
          delete submitTouched?.[key];
        });
      }
    } else if (attr?.reversedependent) {
      if (Array.isArray(attr.reversedependent)) {
        attr.reversedependent.forEach((key) => {
          delete submitErrors?.[key];
          delete submitTouched?.[key];
        });
      } else if (typeof attr.reversedependent === "string") {
        const key = attr.reversedependent;
        delete submitErrors?.[key];
        delete submitTouched?.[key];
      }
    } else if (attr?.dependent) {
      if (Array.isArray(attr.dependent)) {
        attr.dependent.forEach((key) => {
          delete submitErrors?.[key];
          delete submitTouched?.[key];
        });
      } else if (typeof attr.dependent === "string") {
        const key = attr.dependent;
        delete submitErrors?.[key];
        delete submitTouched?.[key];
      }
    }
    const errorsData = getDataFromStorage(`${encounterId}2`);
    const previousValues = getDataFromStorage(encounterId);

    let sectionsWithEmptyFields = [];
    // Use existing errors if available
    if (errorsData) {
      sectionsWithEmptyFields = errorsData;
    }

    const hasChanged =
      JSON.stringify(previousValues) !==
      JSON.stringify(formikRef?.current?.values);
    const hasChanged1 =
      JSON.stringify(previousValues) !== JSON.stringify(updatedValues);

    try {
      if (updatedValues === undefined) {
        if (hasChanged) {
          const validation = validateRequiredFields(
            crfValidationAttributes,
            formikRef?.current?.values
          );
          StorageHelper.set(
            encounterId,
            JSON.stringify(formikRef?.current?.values)
          );
          const groupedFields = groupBySection(validation.emptyFields);
          sectionsWithEmptyFields = groupedFields.map((group) => group.section);
          StorageHelper.set(
            `${encounterId}2`,
            JSON.stringify(sectionsWithEmptyFields)
          );
          setAllerrors(sectionsWithEmptyFields);
        }
      } else {
        if (hasChanged1) {
          const validation = validateRequiredFields(
            crfValidationAttributes,
            updatedValues
          );
          StorageHelper.set(encounterId, JSON.stringify(updatedValues));
          const groupedFields = groupBySection(validation.emptyFields);
          sectionsWithEmptyFields = groupedFields.map((group) => group.section);
          StorageHelper.set(
            `${encounterId}2`,
            JSON.stringify(sectionsWithEmptyFields)
          );
          setAllerrors(sectionsWithEmptyFields);
        }
      }
    } catch (error) {
      console.error("Validation error:", error);
      // Optionally handle error state
    }
  };
  function checkAllEmpty(obj, fields, name, type, cascadeValidation, options) {
    let cascadevalidate = false;
    let dependentValidationarray2 = [];
    if (obj?.["basicVisit_typeofvisit"] === "Follow Up Visit") {
      dependentValidationarray2 = [
        "TreatmentInterventionCurrentMedication_None_isChecked",
        "TreatmentIntervention_acetylcholinesteraseinhibitorsCurrentMedication_isChecked",
        "TreatmentIntervention_corticosteroidstreatmentCurrentMedication_isChecked",
        "TreatmentIntervention_CyclicintravenousimmunoglobulinsIVIGCurrentMedication_isChecked",
        "TreatmentIntervention_CyclicPlasmapheresisPLEXCurrentMedication_isChecked",
        "TreatmentIntervention_ImmunosuppressiveTreatmentCurrentMedication_isChecked",
        "TreatmentIntervention_BoneMarrowTransplant(BMT)CurrentMedication_isChecked",
        "TreatmentIntervention_corticosteroidstreatmentCurrentMedicationothers_isChecked",
      ];
    } else {
      dependentValidationarray2 = [
        "TreatmentInterventionCurrentMedication_None_isChecked",
        "TreatmentIntervention_acetylcholinesteraseinhibitorsCurrentMedication_isChecked",
        "TreatmentIntervention_corticosteroidstreatmentCurrentMedication_isChecked",
        "TreatmentIntervention_CyclicintravenousimmunoglobulinsIVIGCurrentMedication_isChecked",
        "TreatmentIntervention_CyclicPlasmapheresisPLEXCurrentMedication_isChecked",
        "TreatmentIntervention_ImmunosuppressiveTreatmentCurrentMedication_isChecked",
        "TreatmentIntervention_corticosteroidstreatmentCurrentMedicationothers_isChecked",
      ];
    }
    const dependentValidationarray1 = [
      "TreatmentIntervention_PreviousNone_isChecked",
      "TreatmentIntervention_CyclicintravenousimmunoglobulinsIVIG_isChecked",
      "TreatmentIntervention_corticosteroidstreatment_isChecked",
      "TreatmentIntervention_acetylcholinesteraseinhibitors_isChecked",
      "TreatmentIntervention_CyclicPlasmapheresisPLEX_isChecked",
      "TreatmentIntervention_BoneMarrowTransplant(BMT)_isChecked",
      "TreatmentIntervention_rapidimmunotherapies_isChecked",
      "TreatmentIntervention_ImmunosuppressiveTreatment_isChecked",
      "TreatmentIntervention_others_isChecked",
    ];
    const dependentValidationarray4 = [
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_frustratedmg",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_troubleeyes",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_troubleeating",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_socialactivity",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_enjoyhobbies",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_needsoffamily",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_makeplans",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_occupationalskills",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_difficultyspeaking",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_troubledriving",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_depressed",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_troublewalking",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_troublepublicplaces",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_feeloverwhelmed",
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_troubleperformingpersonal",
    ];

    const dependentValidationarray3 = [
      "Diagnosis_mgseverityclassificationon_unknown_isChecked",
      "Diagnosis_mgseverityclassificationon_MGFA_isChecked",
    ];

    const dependentValidationarray5 = [
      "ClinicalAssessment_myastheniagravisqualityoflifeitemscale_totalscore",
    ];

    if (obj === undefined || typeof obj !== "object" || obj === null) {
      return false;
    }
    let validKeys;
    let validKeyssecond;
    if (fields === 1) {
      validKeys = dependentValidationarray1.filter((key) =>
        obj.hasOwnProperty(key)
      );
    }
    if (fields === 2) {
      validKeys = dependentValidationarray2.filter((key) =>
        obj.hasOwnProperty(key)
      );
    }
    if (fields === 3) {
      validKeys = dependentValidationarray3.filter((key) =>
        obj.hasOwnProperty(key)
      );
    }
    if (fields === 4) {
      validKeys = dependentValidationarray4.filter((key) =>
        obj.hasOwnProperty(key)
      );
    }
    if (fields === 4) {
      validKeyssecond = dependentValidationarray5.filter((key) =>
        obj.hasOwnProperty(key)
      );
    }
    if (fields === 4) {
      const values = validKeys?.map((key) => obj[key]);

      let allNotEmpty =
        Array.isArray(values) &&
        values.every(
          (value) =>
            value === "" ||
            value === null ||
            value === undefined ||
            value === "false" ||
            value === false ||
            value === '{"cascadervalue":[],"value":{}}'
        );

      // Return true if all fields are empty, false if all fields are filled
      let result = allNotEmpty
        ? true
        : values.every(
            (value) => value !== "" && value !== null && value !== undefined
          );

      if (fields === 4) {
        if (allNotEmpty) {
          const valuess = validKeyssecond.map((key) => obj[key]);

          let allEmptys =
            Array.isArray(valuess) &&
            valuess.every(
              (value) => value !== "" && value !== null && value !== undefined
            );

          if (!allEmptys) {
            return true;
          } else {
            return false;
          }
        } else {
          if (!result) {
            return true;
          } else {
            return false;
          }
        }
      }
    } else {
      const values = validKeys?.map((key) => obj?.[key]);
      let allEmpty =
        Array.isArray(values) &&
        values.every(
          (value) =>
            value === "" ||
            value === null ||
            value === undefined ||
            value === "false" ||
            value === false ||
            value === '{"cascadervalue":[],"value":{}}'
        );

      if (allEmpty) {
        return true;
      } else {
        return false;
      }
    }
  }
  function validateField(
    fieldValue,
    format,
    name,
    label,
    error,
    emptyRequiredFields,
    isFieldValid = true
  ) {
    if (!isFieldValid) {
      return;
    }
    if (format === "array") {
      if (!Array.isArray(fieldValue) || fieldValue.length === 0) {
        emptyRequiredFields.push({
          name,
          label: label || name,
          error: `${label || name} is required`,
        });
      }
    } else {
      if (
        fieldValue === undefined ||
        fieldValue === null ||
        fieldValue.toString() === ""
      ) {
        emptyRequiredFields.push({
          name,
          label: label || name,
          error: error === "" ? `${label || name} is required` : error,
        });
      }
    }
  }

  function validateRequiredFields(attributes, formData) {
    if (!Array.isArray(attributes)) {
      return { isValid: false, emptyFields: [], error: "Invalid attributes" };
    }

    const emptyRequiredFields = [];

    try {
      for (const attribute of attributes) {
        const {
          name,
          label,
          error,
          required,
          regex,
          format,
          dependentValidation,
          fieldValueValidation,
          dependentValidationarray,
          cascadeValidation,
          cascadevalidation,
          showonlybasline,
          checkVisitType,
          Accordionischecked,
          onlyBasic,
          type,
          dependents,
          fieldValues,
          options,
        } = attribute;
        if (!name) continue;

        const fieldValue = formData[name];

        if (dependentValidationarray) {
          let shouldValidate = false;
          if (
            showonlybasline &&
            formData?.["basicVisit_typeofvisit"] === "Baseline Visit"
          ) {
            shouldValidate = checkAllEmpty(
              formData,
              dependentValidationarray,
              name,
              type,
              cascadeValidation,
              options
            );
          }
          if (showonlybasline === undefined) {
            shouldValidate = checkAllEmpty(
              formData,
              dependentValidationarray,
              name,
              type,
              cascadeValidation,
              options
            );
          }

          if (shouldValidate) {
            if (format === "array") {
              if (!Array.isArray(fieldValue) || fieldValue.length === 0) {
                emptyRequiredFields.push({
                  name,
                  label: label || name,
                  error: error || `${label || name} is required`,
                });
              }
            } else {
              if (!fieldValue || fieldValue === "") {
                emptyRequiredFields.push({
                  name,
                  label: label || name,
                  error: error || `${label || name} is required`,
                });
              }
            }
          }
        } else {
          if (dependentValidation) {
            const dependentValue = formData[dependentValidation];
            if (required) {
              if (Array.isArray(fieldValueValidation)) {
                const shouldValidate = fieldValueValidation.some((elems) =>
                  dependentValue?.includes(elems)
                );

                if (shouldValidate) {
                  validateField(
                    fieldValue,
                    format,
                    name,
                    label,
                    error,
                    emptyRequiredFields
                  );
                }
              } else {
                if (cascadevalidation) {
                  if (
                    formData?.[name] &&
                    type === "cascade" &&
                    cascadeValidation
                  ) {
                    let countValidation = [];
                    options.forEach((elems) => {
                      elems.children.forEach((ele) => {
                        if (ele.label === cascadeValidation) {
                          countValidation.push(`${ele.value} ->`);
                        }
                      });
                    });

                    try {
                      const parsedValue = JSON.parse(formData[name]);
                      const cascadeValidate = countValidation.every((str1) =>
                        parsedValue.cascadervalue.some((str2) =>
                          str2.includes(str1)
                        )
                      );

                      if (
                        formData?.[dependentValidation] === fieldValueValidation
                      ) {
                        if (
                          !cascadeValidate ||
                          formData[name] === '{"cascadervalue":[],"value":{}}'
                        ) {
                          emptyRequiredFields.push({
                            name,
                            label: label || name,
                            error: error || `${label || name} is required`,
                          });
                        } else {
                          try {
                            if (
                              !isAtLeastOneNonChildSelected(
                                options,
                                parsedValue.cascadervalue
                              )
                            ) {
                              if (
                                !isAtLeastOneFieldNonEmpty(parsedValue.value)
                              ) {
                                emptyRequiredFields.push({
                                  name,
                                  label: label || name,
                                  error:
                                    error || `${label || name} is required`,
                                });
                              }
                            }
                          } catch (e) {
                            console.error("Invalid JSON format", e);
                          }
                        }
                      }
                    } catch (e) {
                      console.error(
                        "Invalid JSON format for cascade value:",
                        e
                      );
                    }
                  } else if (formData?.[name] && type === "cascade") {
                    try {
                      const parsedValue = JSON.parse(formData[name]);

                      if (
                        formData?.[dependentValidation] === fieldValueValidation
                      ) {
                        if (
                          formData[name] === '{"cascadervalue":[],"value":{}}'
                        ) {
                          emptyRequiredFields.push({
                            name,
                            label: label || name,
                            error: error || `${label || name} is required`,
                          });
                        } else {
                          if (
                            !isAtLeastOneNonChildSelected(
                              options,
                              parsedValue.cascadervalue
                            )
                          ) {
                            if (!isAtLeastOneFieldNonEmpty(parsedValue.value)) {
                              emptyRequiredFields.push({
                                name,
                                label: label || name,
                                error: error || `${label || name} is required`,
                              });
                            }
                          }
                        }
                      }
                    } catch (e) {
                      console.error("Invalid JSON format", e);
                    }
                  } else {
                    if (
                      formData?.[dependentValidation] === fieldValueValidation
                    ) {
                      validateField(
                        formData[name],
                        format,
                        name,
                        label,
                        error,
                        emptyRequiredFields
                      );
                    }
                  }
                }
              }
            } else {
              if (Array.isArray(fieldValueValidation)) {
                if (dependentValue) {
                  const shouldValidate = fieldValueValidation.some((elems) =>
                    dependentValue?.includes(elems)
                  );

                  if (shouldValidate) {
                    validateField(
                      fieldValue,
                      format,
                      name,
                      label,
                      error,
                      emptyRequiredFields
                    );
                  }
                }
              } else {
                if (cascadevalidation) {
                  if (
                    formData?.[dependentValidation] === fieldValueValidation
                  ) {
                    if (
                      fieldValue === "" ||
                      fieldValue === '{"cascadervalue":[],"value":{}}'
                    ) {
                      emptyRequiredFields.push({
                        name,
                        label: label || name,
                        error: error || `${label || name} is required`,
                      });
                    }
                  }
                } else if (checkVisitType) {
                  const visitType = formData[checkVisitType];

                  if (
                    (onlyBasic && visitType === "Baseline Visit") ||
                    (!onlyBasic && visitType === "Follow Up Visit")
                  ) {
                    const isFieldValid =
                      formData[dependentValidation] === fieldValueValidation;
                    if (isFieldValid) {
                      validateField(
                        fieldValue,
                        format,
                        name,
                        label,
                        error,
                        emptyRequiredFields
                      );
                    }
                  }
                } else {
                  const isFieldValid =
                    formData[dependentValidation]?.toString() ===
                    fieldValueValidation?.toString();
                  if (
                    Accordionischecked &&
                    (formData?.[
                      "ParaClinicalInvestigation_serologicaltests_numberoftest"
                    ] === undefined ||
                      formData?.[
                        "ParaClinicalInvestigation_serologicaltests_numberoftest"
                      ] === "")
                  ) {
                    continue;
                  }

                  if (isFieldValid) {
                    validateField(
                      fieldValue,
                      format,
                      name,
                      label,
                      error,
                      emptyRequiredFields
                    );
                  }
                }
              }
            }
          } else {
            if (dependents) {
              const dependentValue = parseInt(formData[dependents]);
              if (
                parseInt(fieldValues) <= parseInt(dependentValue) &&
                (fieldValue === false ||
                  fieldValue === "" ||
                  fieldValue === undefined)
              ) {
                emptyRequiredFields.push({
                  name,
                  label: label || name,
                  error: error || `${label || name} is required`,
                });
              }
            } else {
              if (required) {
                let isValid = true;

                switch (format) {
                  case "email":
                    isValid =
                      !fieldValue ||
                      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue);
                    break;
                  case "String":
                    if (format === "String") {
                      if (required) {
                        let isValid = true;

                        if (type === "cascade") {
                          try {
                            if (
                              fieldValue === '{"cascadervalue":[],"value":{}}'
                            ) {
                              isValid = false;
                            } else {
                              const parsedValue = JSON.parse(fieldValue);
                              const hasNonChildSelected =
                                isAtLeastOneNonChildSelected(
                                  options,
                                  parsedValue.cascadervalue
                                );

                              if (hasNonChildSelected) {
                                isValid = true;
                              } else {
                                isValid = isAtLeastOneFieldNonEmpty(
                                  parsedValue.value
                                );
                              }
                            }
                          } catch (e) {
                            isValid = false;
                          }
                        } else {
                          // Patient-record fields come back as null when never answered
                          // (e.g. PII-less patients are created before the form is filled),
                          // so null counts as empty here, as it already does in validateField.
                          isValid =
                            fieldValue !== undefined &&
                            fieldValue !== null &&
                            fieldValue !== "";
                        }

                        if (!isValid) {
                          emptyRequiredFields.push({
                            name,
                            label: label || name,
                            error: error || `${label || name} is required`,
                          });
                        }
                      }
                    }
                    break;
                  case "date":
                    isValid =
                      fieldValue !== null &&
                      fieldValue !== undefined &&
                      fieldValue !== "";
                    break;
                  case "array":
                    isValid =
                      Array.isArray(fieldValue) && fieldValue.length > 0;
                    break;
                  case "boolean":
                    if (required) {
                      isValid = fieldValue === true;
                    }
                    break;
                  default:
                  // isValid = fieldValue !== undefined && fieldValue !== "";
                }

                if (!isValid) {
                  emptyRequiredFields.push({
                    name,
                    label: label || name,
                    error: error || `${label || name} is required`,
                  });
                }
              }
            }
          }
        }
        if (regex && fieldValue) {
          try {
            const pattern = new RegExp(regex);
            if (!pattern.test(fieldValue)) {
              emptyRequiredFields.push({
                name,
                label: label || name,
                error: `${label || name} is invalid`,
              });
            }
          } catch (regexError) {}
        }
        if (type === "MenuList" && options?.[0]?.attribute) {
          const nestedValidation = validateRequiredFields(
            options[0].attribute,
            formData
          );
          emptyRequiredFields.push(...nestedValidation.emptyFields);
        }

        if (type === "Accordion" && options) {
          const nestedValidation = validateRequiredFields(options, formData);
          emptyRequiredFields.push(...nestedValidation.emptyFields);
        }
      }

      return {
        isValid: emptyRequiredFields.length === 0,
        emptyFields: emptyRequiredFields,
      };
    } catch (error) {
      return {
        isValid: false,
        emptyFields: [],
        error: "Validation failed",
      };
    }
  }
  function isAtLeastOneNonChildSelected(options, selectedValues) {
    function buildValueMap(nodes) {
      const map = new Map();
      const parentMap = new Map();

      function traverse(node) {
        if (node.children && node.children.length > 0) {
          parentMap.set(
            node.value,
            node.children.map((child) => child.value)
          );
          node.children.forEach((child) => {
            traverse(child);
          });
        } else {
          map.set(node.value, true);
        }
      }

      nodes.forEach((node) => {
        traverse(node);
      });

      return { map, parentMap };
    }

    const { map: valueMap, parentMap } = buildValueMap(options);

    const hasNonChildSelected = selectedValues.some((value) =>
      valueMap.has(value)
    );

    const hasParentWithoutChildrenSelected = selectedValues.some((value) => {
      if (parentMap.has(value)) {
        const children = parentMap.get(value);
        // Check if none of the children are selected
        return !children.some((child) => selectedValues.includes(child));
      }
      return false;
    });

    return hasNonChildSelected && !hasParentWithoutChildrenSelected;
  }

  function isAtLeastOneFieldNonEmpty(fieldValues) {
    return Object.values(fieldValues).some((value) => value.trim() !== "");
  }
  function groupBySection(fields) {
    const sections = new Map();

    fields.forEach((field) => {
      // Split the name by underscore and get the first part
      const [section] = field.name.split("_");

      if (!sections.has(section)) {
        sections.set(section, []);
      }

      sections.get(section).push({
        ...field,
        section,
      });
    });

    // Convert Map to array of objects
    return Array.from(sections).map(([section, fields]) => ({
      section,
      fields,
    }));
  }

  // Function to update follow-ups with baseline data before navigation
  const updateFollowUpsFromBaseline = (callback, status = null) => {
    const isBaselineVisit =
      encountedDatamain?.details?.basicVisit?.typeofvisit === "Baseline Visit";
    const patientId = encountedDatamain?.patient_id;
    const followUpCount = encounterData?.GetEncountersByPatientId?.length;
    const value = formikRef.current.values;
    const originalFormat = convertToOriginalFormat(value);
    const values = postProcessData(originalFormat);
    // Only proceed if status is 5
    if (status && parseInt(status) !== 5) {
      if (callback) callback();
      return;
    }

    if (isBaselineVisit && followUpCount > 0 && patientId) {
      UpdatePatientFollowUpsDetails({
        variables: {
          patient_id: parseInt(patientId),
          partialDetails: values,
        },
        onCompleted: (updateResult) => {
          console.log(
            `Updated ${updateResult?.UpdatePatientFollowUpsDetails?.updatedCount} follow-ups with baseline data`
          );
          if (callback) callback();
        },
        onError: (error) => {
          console.error("Error updating follow-ups:", error);
          if (callback) callback();
        },
      });
    } else {
      if (callback) callback();
    }
  };
  const handleApproval = (id, val, remark) => {
    setMainPageloading(true);
    delete val.demography;
    delete val.PPCI;

    const isBaselineVisit =
      encountedDatamain?.details?.basicVisit?.typeofvisit === "Baseline Visit";
    const patientId = encountedDatamain?.patient_id;
    const followUpCount = encounterData?.GetEncountersByPatientId?.length;
    console.log("isBaselineVisit", isBaselineVisit, followUpCount);

    // if (isBaselineVisit && followUpCount > 0 && patientId) {
    //   const baselineDetails = encountedDatamain?.details || {};

    //   UpdatePatientFollowUpsDetails({
    //     variables: {
    //       patient_id: parseInt(patientId),
    //       partialDetails: baselineDetails,
    //     },
    //     onCompleted: (updateResult) => {
    //       console.log(
    //         `Updated ${updateResult?.UpdatePatientFollowUpsDetails?.updatedCount} follow-ups with baseline data`
    //       );

    //       Update_Encounter({
    //         variables: {
    //           encounter_id: parseInt(id),
    //           status: val,
    //           remark,
    //         },
    //         onCompleted: () => {
    //           setMessage(
    //             `CRF reviewed successfully. ${
    //               updateResult?.UpdatePatientFollowUpsDetails?.updatedCount || 0
    //             } follow-up(s) updated.`
    //           );
    //           setAlertOption(true);
    //           setEncountedDataLatestStatus(parseInt(val));
    //           setApprove(false);
    //           setMainPageloading(false);

    //           setTimeout(() => {
    //             setAlertOption(false);
    //             navigate("/app/patients/patientlist");
    //           }, 1000);
    //         },
    //         onError: (error) => {
    //           showMutationError(error);
    //           setMainPageloading(false);
    //         },
    //       });
    //     },
    //     onError: (error) => {
    //       console.error("Error updating follow-ups:", error);
    //     },
    //   });
    // } else {
    Update_Encounter({
      variables: {
        encounter_id: parseInt(id),
        status: val,
        remark,
      },
      onCompleted: () => {
        setMessage("CRF reviewed successfully");
        setAlertOption(true);
        setEncountedDataLatestStatus(parseInt(val));
        setApprove(false);
        setMainPageloading(false);

        setTimeout(() => {
          setAlertOption(false);
          updateFollowUpsFromBaseline(() => {
            navigate("/app/patients/patientlist");
          }, val);
        }, 1000);
      },
      onError: (error) => {
        showMutationError(error);
      },
    });
    // }
  };

  const handleEncounter = (data) => {
    setMainPageloading(true);
    const originalFormat = convertToOriginalFormat(data);
    const values = postProcessData(originalFormat);
    const encounterDetails = values ? { ...values } : values;
    if (encounterDetails) {
      delete encounterDetails.demography;
      delete encounterDetails.PPCI;
    }
    UpdatePatientWithEncounter({
      variables: {
        patientId: encountedDatamain?.["patient_id"],
        input: {
          Demographic: wrapDemographic({
            dob: values?.demography?.dateofbirth,
            age:
              values?.demography?.year === ""
                ? null
                : `${values?.demography?.year}/${values?.demography?.month}`,
            education: values?.demography?.educationallevel,
            employment: values?.demography?.employment,
            gender: values?.demography?.gender,
            city: values?.demography?.city,
            region: values?.demography?.region,
            country: values?.demography?.countrylist,
            country_of_residence: getCountryOfResidence(values?.demography),
            marital: values?.demography?.maritalstatus,
            nationality: values?.demography?.nationality,
            smoking_status: values?.demography?.smokerstatus,
            is_draft: false,
            consentform: values?.PPCI?.consentform,
            ...ppciDemographic(() => ({
              email: values?.PPCI?.email,
              first_name: values?.PPCI?.firstname,
              last_name: values?.PPCI?.lastname,
              mobile: values?.PPCI?.phonenumber,
              mrn_no: values?.PPCI?.mrnno,
              national_id: values?.PPCI?.nationalid?.toString() || params?.nationalId?.toString(),
            })),
          }),
        },
        encounterId: parseInt(params?.encounterId),
        encounterDetails,
      },
      onCompleted: () => {
        handleFeeback(params?.encounterId, 5, "Quality User");
      },
      onError: (error) => {
        showMutationError(error);
      },
    });
  };
  const handleFeeback = (id, status, user) => {
    SubmitComment({
      variables: {
        encounterId: parseInt(id),
        status: status,
      },
      onCompleted: (data) => {
        if (
          data?.SubmitComment?.not_submitted_count === 0 &&
          parseInt(data?.SubmitComment.encounter_report_status) !== 5
        ) {
          setMessage("No Feedback Submitted");
          setAlertOption(true);
          setMainPageloading(false);
          setSubmitFeedback(false);
          setTimeout(() => {
            setAlertOption(false);
          }, 1000);
        } else {
          if (encountedDataLatestStatus === 4) {
            setMessage("Feedback and Patient Record Updated Successfully");
            setAlertOption(true);
            setMainPageloading(false);
            setEncountedDataLatestStatus(
              parseInt(data?.SubmitComment.encounter_report_status)
            );
          }
          if (
            encountedDataLatestStatus === 2 ||
            encountedDataLatestStatus === 3
          ) {
            setMessage(
              `The ${data?.SubmitComment?.visit_type}(${
                data?.SubmitComment?.encounter_count - 1 !== 0
                  ? data?.SubmitComment?.encounter_count - 1
                  : null
              }) - ${
                data?.SubmitComment?.patient_registry_no
              } reopened to the Doctor successfully`
            );
            setAlertOption(true);
            setMainPageloading(false);
            setEncountedDataLatestStatus(
              parseInt(data?.SubmitComment.encounter_report_status)
            );
          } else {
            setMessage(`The CRF Returned to the ${user} successfully`);
            setAlertOption(true);
            setSubmitFeedback(false);
            setMainPageloading(false);
            setEncountedDataLatestStatus(
              parseInt(data?.SubmitComment.encounter_report_status)
            );
          }
          setTimeout(() => {
            setAlertOption(false);
            updateFollowUpsFromBaseline(() => {
              navigate("/app/patients/patientlist");
            }, data?.SubmitComment?.encounter_report_status);
          }, 1000);
        }
      },
      onError: (error) => {
        showMutationError(error);
        setMainPageloading(false);
      },
    });
  };
  // Function to get and parse data from storage
  function getDataFromStorage(key) {
    let storedData = StorageHelper.get(key);
    if (storedData) {
      try {
        return JSON.parse(storedData);
      } catch (e) {
        console.error("Error parsing stored data", e);
        return null;
      }
    }
    return null;
  }
  const [retrieveDatas, setretrieveDatas] = useState(null);
  // Formik (enableReinitialize) deep-compares initialValues on every render. Parsing storage
  // each render gave a fresh object that never matched the one fields fill in while
  // rendering, so Formik kept resetting and could hit "Maximum update depth exceeded".
  // Reuse the parsed object until the stored text itself changes.
  const retrievedDataCacheRef = useRef({ key: null, raw: null, data: null });
  const getRetrievedData = (key) => {
    const raw = StorageHelper.get(key);
    const cache = retrievedDataCacheRef.current;
    if (cache.key === key && cache.raw === raw) return cache.data;
    const data = getDataFromStorage(key);
    retrievedDataCacheRef.current = { key, raw, data };
    return data;
  };
  let retrievedData = null;
  // Using the function to retrieve the data
  let encounterId = encountedDatamain?.["encounter_id"];

  if (urlWindow.pathname.split("/")[3] === "newPatient") {
    retrievedData = getRetrievedData(params?.["nationalId"]);
    if (retrieveDatas === null && retrievedData !== null) {
      setretrieveDatas(true);
    }
  } else {
    if (encountedDatamain) {
      if (Object.keys(encountedDatamain).length > 0) {
        retrievedData = getRetrievedData(encounterId);
        if (retrieveDatas === null) {
          setretrieveDatas(true);
        }
      }
    }
  }
  // After a patient / visit is created, land once on Basic Visit or Living Status.
  // This used to queue a timer on every render; timers queued before the user clicked
  // Next/Previous still fired afterwards and pulled the CRF back to Basic Visit.
  const landingFormRef = useRef(patient_form);
  landingFormRef.current = patient_form;
  useEffect(() => {
    // Wait for the loader: for patients with several visits the form is rebuilt late,
    // and that rebuild resets the section, which would undo the landing.
    if (!encounterId || pageLoad) return;
    const landingSection = getDataFromStorage("LivingStatus");
    if (landingSection === null) return;
    const timer = setTimeout(() => {
      StorageHelper.remove("LivingStatus");
      const target =
        landingSection === "LivingStatus" ? "LivingStatus" : "basicVisit";
      if (target === "basicVisit" && landingSection === patient_selected_section) {
        return;
      }
      // Step index of the target: 1 when Personal Information is the first step,
      // 0 for Basic Visit on PII-less (UAE) forms, which have no Personal Information.
      const targetIndex = landingFormRef.current?.sections?.findIndex(
        (e) => e?.key === target
      );
      // A key left over from another visit can name a section this form doesn't have
      // (e.g. Living Status on a baseline); don't move the CRF in that case.
      if (targetIndex === -1) return;
      setSelectedSection(target);
      setActiveStep(targetIndex ?? 1);
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [encounterId, pageLoad]);
  function removeKeysWithPrefix(obj, prefix) {
    const result = {};

    for (let key in obj) {
      if (!key.startsWith(prefix)) {
        result[key] = obj[key]; // Add key-value pair if it doesn't start with the prefix
      }
    }

    return result;
  }
  const [oncompleted, setOncompleted] = useState(null);
  useEffect(() => {
    if (formikRef.current) {
      if (oncompleted !== null) {
        formikRef.current.validateForm().then((resp) => {
          let err = {};
          let processeddata = postProcessData(resp);

          if (processeddata) {
            err = preProcessData(processeddata);
          }
          formikRef.current.setErrors({});
          formikRef.current.setTouched({});
          setCompleted(err);
        });
      }
    }
  }, [patient_selected_section, oncompleted]);
  useEffect(() => {
    StorageHelper.remove("Rerender");
  }, [params]);

  let sectionvalue = null;

  sectionvalue = getDataFromStorage("Rerender");

  if (sectionvalue !== null) {
    if (sectionvalue !== patient_selected_section) {
      const index = patient_form?.sections.findIndex(
        (e) => e?.key === sectionvalue
      );
      StorageHelper.remove("Rerender");
      setSelectedSection(sectionvalue);
      setActiveStep(index);
    }
  }
  let addPatientButton = getActionRbac("patients", "add");
  let edit = getActionRbac("patients", "edit_patient_form");
  const removeKeys = (obj, keysToRemove) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (!keysToRemove.includes(key)) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };

  useEffect(() => {
    if (formikRef?.current?.values !== undefined) {
      setTimeout(() => {
        const errorsData = getDataFromStorage(`${encounterId}2`);
        let sectionsWithEmptyFields = [];
        // Use existing errors if available
        if (errorsData) {
          sectionsWithEmptyFields = errorsData;
        }
        try {
          const validation = validateRequiredFields(
            crfValidationAttributes,
            formikRef?.current?.values
          );

          StorageHelper.set(
            encounterId,
            JSON.stringify(formikRef?.current?.values)
          );
          const groupedFields = groupBySection(validation.emptyFields);
          sectionsWithEmptyFields = groupedFields.map((group) => group.section);
          StorageHelper.set(
            `${encounterId}2`,
            JSON.stringify(sectionsWithEmptyFields)
          );
          setAllerrors(sectionsWithEmptyFields);
          console.log("Manoj3", validation);
        } catch (error) {
          console.error("Validation error:", error);
          // Optionally handle error state
        }
      }, 200);
    }
  }, [patient_form?.attribute]);

  const isDoctor = user?.role_id == ENV.doctor_role_id;
  const crfHeaderEncounter =
    Object.keys(encounterdata).length > 0
      ? encounterdata?.AddEncounter
      : encountedDatamain;
  const crfHeaderName = isDoctor
    ? crfHeaderEncounter?.patient_name
    : crfHeaderEncounter?.current_doctor;
  const showCrfHeaderName = !isDoctor || Boolean(crfHeaderName?.trim());

  return (
    <>
      <Grid
        style={{
          height: `calc(100vh - 225px)`, // Adjust height to account for padding
          overflow: "hidden", // Prevent overflow from the main container
          boxSizing: "border-box",
          padding: "0px",
          width: "100%",
          borderRadius: "10px",
        }}
        container
      >
        <Loader open={mainPageloading || pageLoad} />
        <Box
          sx={{
            marginTop: "-24px",
            width: "96vw",
            position: "absolute",
            zIndex: "99999",
          }}
        >
          {autoSaveAlert ? (
            <>
              <LinearProgress color="inherit" />
              <MgpText sx={{ textAlign: "center" }} variant="body2">
                Saving...
              </MgpText>
            </>
          ) : (
            <></>
          )}
        </Box>

        <Grid
          item
          xs={12} // Full width on extra small screens
          sm={4} // 4/12 (33.33%) on small screens and up
          md={3} // 3/12 (25%) on medium screens and up
          sx={{
            background: colors.CRFBGPROGRESS,
            padding: "15px",
            height: `calc(100vh - 225px)`, // Set height to match parent
            overflowY: "auto", // Enable vertical scrolling
          }}
        >
          <MgpText
            variant="h5"
            style={{
              fontWeight: 700,
              color: colors.BLACK,
              fontSize: "20px",

              paddingBottom: "10px",
              paddingTop: "5px",
            }}
          >
            Registration form
          </MgpText>{" "}
          <Divider sx={{ marginBottom: "10px" }} />
          {patient_form?.sections && (
            <div>
              <MgpProgressBar
                commentData={commentData}
                steps={
                  acceptedPathsList?.includes(urlWindow.pathname.split("/")[3])
                    ? newData?.sections
                    : patient_form?.sections
                }
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                completed={completed}
                setCompleted={setCompleted}
                setSelectedSection={setSelectedSection}
                crfErrors={crfErrors}
                crfTouch={crfTouch}
                encountedData={encountedData}
                formikRef={formikRef?.current?.values}
                patient_selected_section={patient_selected_section}
                encountedDataLatestStatus={encountedDataLatestStatus}
                submitErrors={submitErrors}
                params={params}
                Allerrors={Allerrors}
                setAllerrors={setAllerrors}
                forms={patient_form?.attribute}
                encounterId={encounterId}
              />
              <Stack direction={"row"} spacing={1} sx={{ marginTop: "10px" }}>
                {edit &&
                // patient_selected_section ===
                // "Hospitalizations" &&
                (((encountedDataLatestStatus === 4 ||
                  encountedDataLatestStatus === 6 ||
                  !encountedDataLatestStatus) &&
                  patientActive) ||
                  (urlWindow.pathname.split("/")[3] === "Edit" &&
                    patient_selected_section === "PPCI")) &&
                urlWindow.pathname.split("/")[3] !== "newPatient" &&
                urlWindow.pathname.split("/")[3] !== "newVisit" &&
                editable ? (
                  <MgpButton
                    variant="contained"
                    disabled={buttonsLocked}
                    onClick={() => {
                      if (buttonsLocked) return;
                      let isAtLeastOnePositive = true;
                      if (
                        formikRef?.current?.values?.["Diagnosis_typeofmg"] ===
                        "Sero +"
                      ) {
                        const keysToCheck = [
                          "ParaClinicalInvestigation_serologicaltests_AntiAChRAb_Result",
                          "ParaClinicalInvestigation_serologicaltests_AntiMuSK_Result",
                          "ParaClinicalInvestigation_serologicaltests_AntiLRP4_Result",
                        ];
                        isAtLeastOnePositive = keysToCheck.some(
                          (key) =>
                            formikRef?.current?.values?.[key] === "Positive"
                        );
                      }

                      if (!isAtLeastOnePositive) {
                        setserotype(true);
                        setnotemessage(
                          `If Sero+ is selected for "Type of MG" under Diagnosis section, then one of the results for Serological Tests should be positive`
                        );
                      } else {
                        setOncompleted(3);
                        // Rebuild dependent Yup rules against the latest values, then validate
                        validateCrfForm(formikRef.current.values).then((resp) => {
                          if (urlWindow.pathname.split("/")[3] === "Edit") {
                            let err = {};
                            let processeddata =
                              postProcessData(resp)[patient_selected_section];
                            if (processeddata) {
                              err = preProcessData({
                                [patient_selected_section]: processeddata,
                              });
                            }
                            formikRef.current.setErrors(err);
                            // Create a touched object from the errors object
                            const touchedFields = Object.keys(err).reduce(
                              (acc, key) => {
                                acc[key] = true;
                                return acc;
                              },
                              {}
                            );

                            // Set all touched fields
                            formikRef.current.setTouched(touchedFields);
                            setSubmitErrors(err);
                            setSubmitTouched(touchedFields);

                            if (!Object.keys(err).length) {
                              if (
                                urlWindow.pathname.split("/")[3] === "Edit" &&
                                patient_selected_section === "PPCI"
                              ) {
                                submitPatient(formikRef.current.values);
                              }
                            } else {
                              setErrorMessage(
                                "Please fill all of the mandatory fields."
                              );
                              setErrorOpen(true);
                            }
                          } else {
                            let err = {};
                            let processeddata = postProcessData(resp);
                            if (processeddata) {
                              err = preProcessData(processeddata);
                            }
                            console.log("preProcessData", err);
                            formikRef.current.setErrors(err);
                            const touchedFields = Object.keys(err).reduce(
                              (acc, key) => {
                                acc[key] = true;
                                return acc;
                              },
                              {}
                            );
                            formikRef.current.setTouched(touchedFields);
                            setSubmitErrors(err);
                            setSubmitTouched(touchedFields);
                            if (!Object.keys(err).length) {
                              if (
                                encountedDataLatestStatus === 4 ||
                                encountedDataLatestStatus === 6
                              ) {
                                handleEncounter(formikRef.current.values);
                              } else {
                                Object.keys(formikRef.current.values).forEach(
                                  (key) => {
                                    let listofmandatory = JSON.parse(
                                      StorageHelper.get("listofmandatory")
                                    );
                                    if (listofmandatory) {
                                      const filteredErrors = Object.keys(err)
                                        .filter((key) =>
                                          listofmandatory.includes(key)
                                        )
                                        .reduce((acc, key) => {
                                          acc[key] = err[key];
                                          return acc;
                                        }, {});

                                      const touchedFields =
                                        listofmandatory.reduce((acc, key) => {
                                          acc[key] = true;
                                          return acc;
                                        }, {});

                                      formikRef.current.setErrors(
                                        filteredErrors
                                      );
                                      formikRef.current.setTouched(
                                        touchedFields
                                      );
                                      setSubmitErrors(filteredErrors);
                                      setSubmitTouched(touchedFields);

                                      if (listofmandatory.includes(key)) {
                                        if (
                                          !formikRef.current.values[key] ||
                                          formikRef.current.values[key]
                                            .toString()
                                            .trim() === ""
                                        ) {
                                          err[key] = "This field is required";
                                        }
                                      }
                                    }
                                  }
                                );
                                console.log(
                                  "preProcessDataa1",
                                  err,
                                  encountedDataLatestStatus
                                );
                                if (Object.keys(err).length === 0) {
                                  setSaveDraft((prev) => 0);
                                  submitPatient(
                                    formikRef.current.values,
                                    "submit",
                                    0
                                  );
                                }
                              }
                            } else {
                              setErrorMessage(
                                "Please fill all of the mandatory fields."
                              );
                              setErrorOpen(true);
                            }
                          }
                        });
                      }
                    }}
                  >
                    Submit
                  </MgpButton>
                ) : null}

                {
                  // patient_selected_section ===
                  // "Hospitalizations" &&
                  ((encountedDataLatestStatus === 1 &&
                    getActionRbac("patients", "approval")) ||
                    (encountedDataLatestStatus === 5 &&
                      getActionRbac("patients", "approval") &&
                      getActionRbac("patients", "patient_comment_all"))) &&
                    editable &&
                    patientActive && (
                      <MgpButton
                        variant="contained"
                        disabled={buttonsLocked}
                        onClick={() => {
                          if (buttonsLocked) return;
                          setSubmitFeedback(params.encounterId);
                        }}
                      >
                        Return to Doctor
                      </MgpButton>
                    )
                }
                {
                  // patient_selected_section ===
                  // "Hospitalizations" &&
                  urlWindow.pathname.split("/")[3] === "Edit" && (
                    <MgpButton
                      variant="contained"
                      disabled={buttonsLocked}
                      onClick={() => {
                        if (buttonsLocked) return;
                        updateFollowUpsFromBaseline(() => {
                          navigate("/app/patients/patientlist");
                        });
                      }}
                    >
                      Cancel
                    </MgpButton>
                  )
                }
                {/* re-open */}
                {
                  // patient_selected_section ===
                  //   "Hospitalizations" &&
                  ((encountedDataLatestStatus === 2 &&
                    getActionRbac("patients", "approval")) ||
                    (encountedDataLatestStatus === 3 &&
                      getActionRbac("patients", "approval") &&
                      getActionRbac("patients", "patient_comment_all"))) &&
                    reopen &&
                    patientActive && (
                      <MgpButton
                        variant="contained"
                        disabled={buttonsLocked}
                        onClick={() => {
                          if (buttonsLocked) return;
                          setSubmitReopen(params.encounterId);
                        }}
                      >
                        Return to Doctor
                      </MgpButton>
                    )
                }
                {
                  // patient_selected_section ===
                  //   "Hospitalizations" &&
                  (encountedDataLatestStatus === 1 ||
                    // encountedDataLatestStatus === 4 ||
                    encountedDataLatestStatus === 5) &&
                    editable &&
                    patientActive && (
                      <RbacWrapper module={"patients"} code={"approval"}>
                        <MgpButton
                          variant="contained"
                          disabled={buttonsLocked}
                          onClick={() => {
                            if (buttonsLocked) return;
                            setApprove(params.encounterId);
                          }}
                        >
                          Approve
                        </MgpButton>
                        {/* <MgpButton
                                    variant="contained"
                                    onClick={() => {
                                      setOpenReject(params.encounterId);
                                    }}
                                  >
                                    Reject
                                  </MgpButton> */}
                      </RbacWrapper>
                    )
                }
              </Stack>
              <div>
                <img
                  src="Itkan Logo.png"
                  alt=""
                  style={{
                    width: "170px", // Adjust the width of the image as needed
                  }}
                />
              </div>
            </div>
          )}
        </Grid>

        {patient_form?.sections && (
          <Grid
            item
            xs={12} // Full width on extra small screens
            sm={8} // 8/12 (66.67%) on small screens and up
            md={9} // 9/12 (75%) on medium screens and up
            sx={{
              background: colors.CRFBG,
              padding: "24px",
              height: `calc(100vh - 225px)`, // Set height to match parent
              overflowY: "auto", // Enable vertical scrolling
            }}
          >
            <Box
              sx={{
                width: "100%",
                paddingLeft: "10px",
                display: "flex",

                background: colors.CRFBG,
                justifyContent: "space-between",
                alignItems: "flex-start", // Align items to the bottom
                whiteSpace: "nowrap", // Ensure content stays in a single line
                paddingBottom: "5px",
                overflowX: "auto", // Enable horizontal scrolling if needed
              }}
            >
              <MgpText
                id="scroller"
                style={{
                  fontWeight: 600,
                  color: colors.BLACK,
                  background: colors.CRFBG,
                  fontSize: "20px",
                  textTransform: "uppercase",
                }}
              >
                {
                  patient_form?.sections.find(
                    (elem) => elem.key === patient_selected_section
                  )?.label
                }
              </MgpText>
              {(patient_selected_section !== "PPCI" ||
                !params?.["nationalId"]) && (
                <Box
                  sx={{
                    width: "100%",
                    paddingLeft: "10px",
                    display: "flex",
                    paddingBottom: "10px",
                    background: colors.CRFBG,
                    justifyContent: "flex-end",
                  }}
                >
                  <Box>
                    <Paper
                      sx={{
                        textAlign: "left",
                        fontWeight: "normal",
                        background: colors.CRFBG,
                      }}
                      elevation={0}
                    >
                      <Stack
                        sx={{
                          textAlign: "left",
                          fontWeight: "normal",
                          background: colors.CRFBG,
                        }}
                        direction="row"
                        gap={2}
                      >
                        <Stack
                          sx={{
                            textAlign: "left",
                            fontWeight: "normal",
                            background: colors.CRFBG,
                          }}
                          direction="column"
                        >
                          {showCrfHeaderName && (
                            <MgpText
                              variant="body2"
                              sx={{
                                textAlign: "left",
                                fontWeight: "normal",
                                background: colors.CRFBG,
                              }}
                            >
                              {isDoctor
                                ? "Patient Name "
                                : "Principal Investigator "}
                            </MgpText>
                          )}
                          <MgpText
                            variant="body2"
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                          >
                            Patient Registration No
                          </MgpText>
                          <MgpText
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                            variant="body2"
                          >
                            Visit Status
                          </MgpText>
                          <MgpText
                            variant="body2"
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                          >
                            Current Visit
                          </MgpText>
                        </Stack>
                        <Stack
                          sx={{
                            textAlign: "left",
                            fontWeight: "normal",
                            background: colors.CRFBG,
                          }}
                          direction="column"
                        >
                          {showCrfHeaderName && (
                            <MgpText
                              variant="body2"
                              sx={{
                                textAlign: "left",
                                fontWeight: "normal",
                                background: colors.CRFBG,
                              }}
                            >
                              :
                            </MgpText>
                          )}
                          <MgpText
                            variant="body2"
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                          >
                            :
                          </MgpText>
                          <MgpText
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                            variant="body2"
                          >
                            :
                          </MgpText>
                          <MgpText
                            variant="body2"
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                          >
                            :
                          </MgpText>
                        </Stack>

                        <Stack
                          sx={{
                            textAlign: "left",
                            fontWeight: "normal",
                            background: colors.CRFBG,
                          }}
                          direction="column"
                        >
                          {showCrfHeaderName && (
                            <MgpText
                              variant="body2"
                              sx={{
                                textAlign: "left",
                                fontWeight: "normal",
                                background: colors.CRFBG,
                              }}
                            >
                              {crfHeaderName}
                            </MgpText>
                          )}
                          <MgpText
                            variant="body2"
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                          >
                            {Object.keys(registry_no).length > 0
                              ? registry_no?.AddPatient?.registry_no
                              : patientData?.ViewPatient?.registryno}
                          </MgpText>
                          <MgpText
                            variant="body2"
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                          >
                            {Object.keys(encounterdata).length > 0
                              ? "Draft"
                              : encountedDatamain?.report_status}
                          </MgpText>
                          <MgpText
                            variant="body2"
                            sx={{
                              textAlign: "left",
                              fontWeight: "normal",
                              background: colors.CRFBG,
                            }}
                          >
                            {Object.keys(encounterdata).length > 0
                              ? getVisitTypeLabelFromFollowUp(
                                  encounterdata?.AddEncounter
                                )
                              : urlWindow.pathname.split("/")[3] === "newVisit"
                              ? "Follow Up Visit"
                              : getVisitTypeLabelFromFollowUp(
                                  encountedDatamain,
                                  encountedDatamain?.["details"]?.[
                                    "basicVisit"
                                  ]?.["typeofvisit"]
                                )}
                          </MgpText>
                        </Stack>
                      </Stack>
                    </Paper>
                  </Box>
                </Box>
              )}
            </Box>

            {reload &&
            ((urlWindow.pathname.split("/")[3] === "newPatient" &&
              retrieveDatas === null) ||
              retrieveDatas === true) ? (
              <Formik
                innerRef={formikRef}
                initialValues={
                  retrievedData === null
                    ? encountedData ||
                      getInitialValue(patient_form?.attribute, {})
                    : urlWindow.pathname.split("/")[3] === "newVisit"
                    ? encountedData ||
                      getInitialValue(patient_form?.attribute, {})
                    : Object.keys(retrievedData).length > 0 && retrievedData
                }
                enableReinitialize={true}
                validateOnChange={false} // Adjust as per your need
                validateOnBlur={false} // Adjust as per your need
                validationSchema={validationSchema}
                onSubmit={(payload) => {}}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  getFieldProps,
                  touched,
                  values,
                  validateForm,
                  setErrors,
                  setFieldError,
                  setTouched,
                  setValues,
                  setFieldTouched,
                }) => {
                  if (JSON.stringify(errors) !== JSON.stringify(crfErrors)) {
                    setCrfError(errors);
                  }
                  if (JSON.stringify(touched) !== JSON.stringify(crfTouch)) {
                    setCrfTouch(touched);
                  }
                  setOncompleted(1);

                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid
                        container
                        spacing={3}
                        direction="row"
                        alignItems="flex-end"
                      >
                        {forms?.map((attr, idx) => {
                          if (
                            attr.showpii === false &&
                            !getActionRbac("view_patient", "view_pii")
                          ) {
                            return <></>;
                          }
                          let commentComponent = null;
                          if (params.encounterId || params.patientId) {
                            commentComponent = (getActionRbac(
                              "patients",
                              "patient_comment"
                            ) ||
                              getActionRbac(
                                "patients",
                                "patient_comment_all"
                              )) && (
                              <MgpComment
                                attr={{
                                  ...attr,
                                  encounterId: params.encounterId,
                                }}
                                pendingPatientId={
                                  params.patientId && !params.encounterId
                                    ? params.patientId
                                    : undefined
                                }
                                section={
                                  patient_form?.sections.find(
                                    (e) => e.key === patient_selected_section
                                  ).label
                                }
                                // Other props as needed
                                showall={true}
                                count={commentData?.counts?.[attr.name]}
                                setCommentData={setCommentData}
                                commentData={commentData}
                                disable={
                                  !patientActive ||
                                  (encountedDataLatestStatus === 2 &&
                                    getActionRbac("patients", "approval") &&
                                    !reopen) ||
                                  (encountedDataLatestStatus === 3 &&
                                    !getActionRbac("patients", "approval")) ||
                                  (encountedDataLatestStatus === 2 &&
                                    !getActionRbac("patients", "approval")) ||
                                  (encountedDataLatestStatus === 1 &&
                                    !getActionRbac("patients", "approval")) ||
                                  (encountedDataLatestStatus === 5 &&
                                    !getActionRbac(
                                      "patients",
                                      "patient_comment_all"
                                    )) ||
                                  (encountedDataLatestStatus === 2 &&
                                    !reopen) ||
                                  getActionRbac("patients", "disable_comment")
                                }
                                bottom={
                                  attr?.type === "toggle"
                                    ? true
                                    : attr?.type === "Accordion"
                                    ? true
                                    : attr?.type === "phone"
                                    ? true
                                    : false
                                }
                              />
                            );
                          }
                          return (
                            <React.Fragment key={idx}>
                              {generateDynamicComponent(
                                attr,
                                touched,
                                errors,
                                values,
                                handleBlur,
                                (e, attributeonchange, updatedValues) => {
                                  handleFormikChange(
                                    e,
                                    attributeonchange,
                                    updatedValues
                                  );
                                },
                                setFieldValue,
                                reload,
                                patientData?.ViewPatient?.is_active === false ||
                                  !editable ||
                                  encountedDataLatestStatus === 1 ||
                                  encountedDataLatestStatus === 3 ||
                                  encountedDataLatestStatus === 4 ||
                                  encountedDataLatestStatus === 6 ||
                                  encountedDataLatestStatus === 5
                                  ? true
                                  : encountedDataLatestStatus === 2 ||
                                    encountedDataLatestStatus === 6
                                  ? true
                                  : !getActionRbac(
                                      "patients",
                                      "edit_patient_form"
                                    ),
                                newVisit,
                                commentComponent,
                                setFieldTouched,
                                commentData,
                                setCommentData,
                                setValues,
                                encountedDataLatestStatus,
                                edit,
                                patientActive,

                                urlWindow.pathname.split("/")[3] === "Edit",
                                patient_form?.sections.find(
                                  (e) => e.key === patient_selected_section
                                ).label,
                                null,
                                reopen,
                                setserotype,
                                setnotemessage,
                                Object.keys(encounterdata).length > 0
                                  ? encounterdata
                                  : encountedDatamain,
                                setErrors,
                                setTouched,
                                submitErrors,
                                submitTouched
                              )}
                            </React.Fragment>
                          );
                        })}
                        <Grid item md={12} gap={3}>
                          <React.Fragment>
                            <Stack direction={"row"} gap={1}>
                              {activeStep === 0 ? (
                                <></>
                              ) : (
                                <MgpButton
                                  variant="contained"
                                  disabled={activeStep === 0 || buttonsLocked}
                                  onClick={handleBack}
                                >
                                  Previous
                                </MgpButton>
                              )}

                              {/* {patient_selected_section === "Hospitalizations" &&
                              !encountedDataLatestStatus && (
                                <MgpButton
                                  variant="contained"
                                  onClick={() => {
                                    validateForm().then((resp) => {
                                      let err = {};
                                      let processeddata = postProcessData(resp);

                                      if (processeddata) {
                                        err = preProcessData(processeddata);
                                      }
                                      setErrors(err);
                                      setTouched(err);
                                      console.log("err", err);
                                      if (!Object.keys(err).length) {
                                        setfinalvalues(values);
                                      } else {
                                        alert(
                                          "Please fill all of the mandatory fields."
                                        );
                                      }
                                    });
                                  }}
                                >
                                  save & Add medication request
                                </MgpButton>
                              )} */}
                              {patient_selected_section !==
                              "Hospitalizations" ? (
                                urlWindow.pathname.split("/")[3] === "Edit" &&
                                patient_selected_section === "PPCI" ? null : (
                                  <MgpButton
                                    variant="contained"
                                    disabled={buttonsLocked}
                                    onClick={() => {
                                      if (buttonsLocked) return;
                                      setOncompleted(2);
                                      if (
                                        patient_selected_section ===
                                          "basicVisit" &&
                                        values["basicVisit_dateofvisit"] ===
                                          "NA"
                                      ) {
                                        setErrorMessage(
                                          values["basicVisit_typeofvisit"] ===
                                            "Follow Up Visit" &&
                                            values["lastfollowupdate"]
                                            ? "Please select a date after the last visit date and within 2 weeks range!"
                                            : "Please select dates within 2 weeks range!"
                                        );
                                        setErrorOpen(true);
                                        setFieldValue(
                                          "basicVisit_dateofvisit",
                                          ""
                                        );
                                        return;
                                      } else if (
                                        patient_selected_section ===
                                          "demography" &&
                                        values["demography_dateofbirth"] ===
                                          "NA"
                                      ) {
                                        setErrorMessage(
                                          "Please enter a valid date!"
                                        );
                                        setErrorOpen(true);
                                        setFieldValue(
                                          "demography_dateofbirth",
                                          ""
                                        );
                                        return;
                                      } else if (
                                        patient_selected_section ===
                                          "Diagnosis" &&
                                        values["Diagnosis_dateofsymptoms"] ===
                                          "NA"
                                      ) {
                                        setErrorMessage(
                                          "Please enter a valid date!"
                                        );
                                        setErrorOpen(true);
                                        setFieldValue(
                                          "Diagnosis_dateofsymptoms",
                                          ""
                                        );
                                        setFieldValue(
                                          "Diagnosis_symptomsage",
                                          ""
                                        );
                                        return;
                                      } else if (
                                        patient_selected_section ===
                                          "Diagnosis" &&
                                        values["Diagnosis_dateofdiagnosis"] ===
                                          "NA"
                                      ) {
                                        setErrorMessage(
                                          "Please enter a valid date!"
                                        );
                                        setErrorOpen(true);
                                        setFieldValue(
                                          "Diagnosis_dateofdiagnosis",
                                          ""
                                        );
                                        setFieldValue(
                                          "Diagnosis_diagnosisage",
                                          ""
                                        );
                                        return;
                                      }
                                      const isQualityUser =
                                        parseInt(user?.role_id) ===
                                        parseInt(ENV.quality_user_role_id);

                                      if (isQualityUser) {
                                        handleNext(values);
                                      } else if (
                                        patientData?.ViewPatient?.is_active ===
                                          false ||
                                        encountedDatamain?.is_active ===
                                          false ||
                                        !editable
                                      ) {
                                        console.log("editable", editable);
                                        handleNext(values);
                                      } else {
                                        validateForm().then((resp) => {
                                          validateForm().then((resp) => {
                                            let err = {};
                                            let processeddata =
                                              postProcessData(resp)[
                                                patient_selected_section
                                              ];

                                            if (processeddata) {
                                              err = preProcessData({
                                                [patient_selected_section]:
                                                  processeddata,
                                              });
                                            }
                                            setErrors(err);
                                            // Create a touched object from the errors object
                                            const touchedFields = Object.keys(
                                              err
                                            ).reduce((acc, key) => {
                                              acc[key] = true;
                                              return acc;
                                            }, {});

                                            // Set all touched fields
                                            setTouched(touchedFields);

                                            const finalerrs = removeKeys(err, [
                                              "TreatmentIntervention",
                                            ]);
                                            if (Object.keys(finalerrs).length) {
                                              const existingErrors =
                                                submitErrors;
                                              const existingTouched =
                                                submitTouched;

                                              const updatedErrors = {
                                                ...existingErrors,
                                                ...finalerrs,
                                              };
                                              const updatedTouched = {
                                                ...existingTouched,
                                                ...touchedFields,
                                              };
                                              setSubmitErrors(updatedErrors);
                                              setSubmitTouched(updatedTouched);
                                            }

                                            if (
                                              Object.keys(finalerrs).length ===
                                              0
                                            ) {
                                              const existingErrors =
                                                removeKeysWithPrefix(
                                                  submitErrors,
                                                  patient_selected_section
                                                );
                                              const existingTouched =
                                                removeKeysWithPrefix(
                                                  submitTouched,
                                                  patient_selected_section
                                                );
                                              const updatedErrors = {
                                                ...existingErrors,
                                                ...finalerrs,
                                              };
                                              const updatedTouched = {
                                                ...existingTouched,
                                                ...touchedFields,
                                              };
                                              setSubmitErrors(updatedErrors);
                                              setSubmitTouched(updatedTouched);
                                              let isAtLeastOnePositive = true;
                                              if (
                                                patient_selected_section ===
                                                  "ParaClinicalInvestigation" &&
                                                values?.[
                                                  "Diagnosis_typeofmg"
                                                ] === "Sero +"
                                              ) {
                                                const keysToCheck = [
                                                  "ParaClinicalInvestigation_serologicaltests_AntiAChRAb_Result",
                                                  "ParaClinicalInvestigation_serologicaltests_AntiMuSK_Result",
                                                  "ParaClinicalInvestigation_serologicaltests_AntiLRP4_Result",
                                                ];
                                                isAtLeastOnePositive =
                                                  keysToCheck.some(
                                                    (key) =>
                                                      values[key] === "Positive"
                                                  );
                                              }

                                              if (!isAtLeastOnePositive) {
                                                setserotype(true);
                                                setnotemessage(
                                                  `If Sero+ is selected for "Type of MG" under Diagnosis section, then one of the results for Serological Tests should be positive`
                                                );
                                              } else {
                                                if (
                                                  patient_selected_section ===
                                                    "PPCI" &&
                                                  params?.["nationalId"] &&
                                                  Object.keys(registry_no)
                                                    .length === 0
                                                ) {
                                                  CreateRegistraionNumber(
                                                    values
                                                  );
                                                } else {
                                                  if (
                                                    patient_selected_section ===
                                                      "LivingStatus" &&
                                                    encountedDataLatestStatus !==
                                                      1 &&
                                                    encountedDataLatestStatus !==
                                                      2 &&
                                                    encountedDataLatestStatus !==
                                                      3 &&
                                                    encountedDataLatestStatus !==
                                                      4 &&
                                                    encountedDataLatestStatus !==
                                                      5 &&
                                                    encountedDataLatestStatus !==
                                                      6 &&
                                                    !params?.nationalId &&
                                                    encountedDatamain?.[
                                                      "details"
                                                    ]?.["typeofvisit"] !==
                                                      "Baseline Visit" &&
                                                    values?.[
                                                      "basicVisit_typeofvisit"
                                                    ] !== "Baseline Visit"
                                                  ) {
                                                    UpdatePatientLivingStatus({
                                                      variables: {
                                                        input: {
                                                          PatientLivingStatus: {
                                                            is_the_patient_alive:
                                                              values?.[
                                                                "LivingStatus_Isthepatientalive"
                                                              ] === "No"
                                                                ? false
                                                                : true,
                                                            date_of_death:
                                                              values?.[
                                                                "LivingStatus_dateofdeath"
                                                              ] === ""
                                                                ? null
                                                                : values?.[
                                                                    "LivingStatus_dateofdeath"
                                                                  ],
                                                            death_related_cause:
                                                              values?.[
                                                                "LivingStatus_DeathRelatedCause"
                                                              ],
                                                            cause_of_death:
                                                              values?.[
                                                                "LivingStatus_CauseofDeath"
                                                              ],
                                                            others_specify:
                                                              values?.[
                                                                "LivingStatus_OthersSpecify"
                                                              ],
                                                          },
                                                        },
                                                        patientId:
                                                          encounterData
                                                            ?.GetEncountersByPatientId?.[0]?.[
                                                            "patient_id"
                                                          ],
                                                      },
                                                      onCompleted: (data) => {
                                                        setMainPageloading(
                                                          false
                                                        );
                                                        handleNext(values);
                                                        var element =
                                                          document.getElementById(
                                                            "scroller"
                                                          );
                                                        element.scrollIntoView();
                                                      },
                                                      onError: (error) => {
                                                        showMutationError(error);
                                                        setMainPageloading(
                                                          false
                                                        );
                                                      },
                                                    });
                                                  } else {
                                                    if (
                                                      (encountedDataLatestStatus ===
                                                        0 ||
                                                        encountedDataLatestStatus ===
                                                          null) &&
                                                      getActionRbac(
                                                        "patients",
                                                        "add"
                                                      )
                                                    ) {
                                                      setSaveDraft((prev) => 2);
                                                      submitPatient(
                                                        formikRef.current
                                                          .values,
                                                        undefined,
                                                        2
                                                      );
                                                    }
                                                    handleNext(values);
                                                    var element =
                                                      document.getElementById(
                                                        "scroller"
                                                      );
                                                    element.scrollIntoView();
                                                  }
                                                }
                                              }
                                            } else {
                                              setErrorMessage(
                                                "Please fill all the mandatory fields having *"
                                              );
                                              setErrorOpen(true);
                                            }
                                          });
                                        });
                                      }
                                    }}
                                  >
                                    Next
                                  </MgpButton>
                                )
                              ) : null}
                            </Stack>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              </Formik>
            ) : null}
          </Grid>
        )}
      </Grid>

      {open && (
        <div>
          <MgpModal
            open={open}
            onClose={handleClose}
            title={"Medication Request"}
          >
            <Stack sx={{ marginX: "2%" }}>
              {/* <MgpText variant="h4">Medication Request</MgpText> */}
              <MedicationRequest
                from={"PATIENT_CRF_FORM"}
                obj={finalvalues}
                viewMode={viewMode}
                newVisit={newVisit}
                handleClose={handleClose}
                setMedicationArray={setMedicationArray}
              />
            </Stack>
          </MgpModal>
        </div>
      )}
      {livingStatusOpen && (
        <MgpModal
          styling={{}}
          open={livingStatusOpen}
          onClose={handleLivingClose}
          title={"Living Status"}
        >
          <Stack sx={{ marginX: "2%" }}>
            {/* <MgpText variant="h4">Medication Request</MgpText> */}
            <LivingStatus
              encounterData={encounterData?.GetEncountersByPatientId}
              setlivingStatusOpen={setlivingStatusOpen}
            />
          </Stack>
        </MgpModal>
      )}
      {approve && (
        <AlertDialog
          open={true}
          negative={() => {
            setApprove(false);
          }}
          positive={(param) => {
            handleApproval(Number(param), 2);
          }}
          param={approve}
          title={"Approve"}
          description={"Are you sure you want to approve?"}
        />
      )}
      {serotype && (
        <NoteAlertDialog
          open={true}
          negative={() => {
            setserotype(false);
          }}
          title={"Note"}
          description={notemessage}
        />
      )}

      {submitFeedback && (
        <AlertDialog
          open={true}
          negative={() => {
            setSubmitFeedback(false);
          }}
          positive={(param) => {
            handleFeeback(Number(param), 4, "Doctor");
            setSubmitFeedback(false);
          }}
          param={submitFeedback}
          title={"Return to Doctor"}
          description={"Are you sure you want to Return to Doctor?"}
        />
      )}
      {submitReopen && (
        <AlertDialog
          open={true}
          negative={() => {
            setSubmitReopen(false);
          }}
          positive={(param) => {
            handleFeeback(Number(param), 6, "Doctor");
            setSubmitReopen(false);
          }}
          param={submitReopen}
          title={"Re-open the Report"}
          description={"Are you sure you want to submit to re-open the report?"}
        />
      )}

      <MgpModal
        open={reject}
        onClose={() => {
          setOpenReject(false);
        }}
      >
        <PatientReject
          reject={reject}
          setOpenReject={setOpenReject}
          Update_Encounter={Update_Encounter}
          setEncountedDataLatestStatus={setEncountedDataLatestStatus}
          message={"Do you want to reject?"}
        />
      </MgpModal>
      <MgpModal open={submitOpen} onClose={handleSubmitClose}>
        <Alert severity="success">Patient CRF Submitted Successfully.</Alert>
      </MgpModal>
      <MgpAlertBar
        open={alertOption}
        setOpen={handleSubmitClose}
        alertType="success"
        message={message}
      />
      <MgpAlertBar
        open={errorOpen}
        setOpen={handleErrorClose}
        alertType="error"
        message={errorMessage}
      />
    </>
  );
};
